let T_EN = {
    "day_monday": "Monday",
    "day_tuesday": "Tuesday",
    "day_wednesday": "Wednesday",
    "day_thursday": "Thursday",
    "day_friday": "Friday",
    "day_saturday": "Saturday",
    "day_sunday": "Sunday",
    "day_monday_short": "Mon",
    "day_tuesday_short": "Tue",
    "day_wednesday_short": "Wed",
    "day_thursday_short": "Thu",
    "day_friday_short": "Fri",
    "day_saturday_short": "Sat",
    "day_sunday_short": "Sun",
    "month_short_january": "Jan",
    "month_short_february": "Feb",
    "month_short_march": "Mar",
    "month_short_april": "Apr",
    "month_short_may": "May",
    "month_short_june": "Jun",
    "month_short_july": "Jul",
    "month_short_august": "Aug",
    "month_short_september": "Sep",
    "month_short_october": "Oct",
    "month_short_november": "Nov",
    "month_short_december": "Dec",
    "month_january": "January",
    "month_february": "February",
    "month_march": "March",
    "month_april": "April",
    "month_may": "May",
    "month_june": "June",
    "month_july": "July",
    "month_august": "August",
    "month_september": "September",
    "month_october": "October",
    "month_november": "November",
    "month_december": "December",
    "t_my_trainings": "My Trainings",
    "t_debtor": "Debt",
    "t_free": "free",
    "t_free_single": "free",
    "t_see_all": "(See all)",
    "t_active": "Active",
    "t_deactive": "Not active",
    "t_reserve": "RESERVE",
    "t_cancel": "CANCEL",
    "t_waiting_list": "Waiting\nlist",
    "t_waiting_list_cancel": "Cancel\nwaiting",
    "label_home": "Home",
    "label_trainings": "Trainings",
    "label_trainings_report": "Training Report",
    "label_users": "Users",
    "label_bar_balance": "Bar balance",
    "label_balance_history": "Balance history",
    "label_balance_adjustment": "Admin adjustment",
    "label_balance_add": "Add",
    "label_balance_subtract": "Subtract",
    "label_balance_updated": "Balance updated successfully",
    "label_balance_amount_required": "Amount is required",
    "label_balance_amount_invalid": "Amount must have up to 2 decimals",
    "label_balance_amount_zero": "Amount cannot be zero",
    "label_balance_note_required": "Note is required",
    "label_balance_source_bill_create": "Bar bill charge",
    "label_balance_source_bill_cancel_return": "Refund (bill cancel)",
    "label_balance_source_bill_mark_paid": "Bill marked as paid",
    "label_balance_source_mobile_app_credit_use": "Product purchased through mobile app",
    "label_balance_source_admin_adjustment": "Admin adjustment",
    "label_balance_change_debit": "Debit",
    "label_balance_change_credit": "Credit",
    "label_balance_users_report": "User balance report",
    "label_only_non_zero_balances": "Only users with non-zero balance are shown",
    "label_history": "History",
    "label_actions": "Actions",
    "label_add_subtract": "Add/Subtract",
    "label_type": "Type",
    "label_source": "Source",
    "label_before": "Before",
    "label_after": "After",
    "label_terms": "Terms",
    "label_notifications": "Notifications",
    "label_payments": "Payments",
    "label_partners": "Partners",
    "label_companies": "Companies",
    "label_membership": "Membership",
    "label_account": "Account",
    "label_logout": "Logout",
    "label_login": "Login",
    "label_payment_expires_today": "Membership expires today",
    "label_payment_already_expires": "Membership has already expired",
    "label_please_extend_membership": "Please renew your membership.",
    "label_success": "Success",
    "label_error": "Error",
    "label_enter_company_code": "Please enter company code.",
    "label_company_code": "Company code",
    "label_company_code_loading": "Loading...",
    "label_company_code_confirm": "Confirm",
    "label_choose_company_code": "Choose company",
    "label_company_not_exist": "Company does not exist.",
    "label_training_success_reserved": "Training successfully reserved.",
    "label_user_not_exist": "User does not exist.",
    "label_please_wait": "Please wait",
    "label_no_data_notifications": "No new notifications",
    "label_download_app": "Download the app by clicking on the icon",
    "label_not_now": "Not now",
    "label_are_you_sure": "Are you sure?",
    "label_are_you_sure_delete_notification": "Are you sure you want to delete the notification?",
    "label_yes": "Yes",
    "label_no": "No",
    "label_primary": "Primary",
    "label_set_as_primary": "Set as primary",
    "label_add_photos": "Add photos",
    "label_add_photos_hint": "Tap to upload product gallery",
    "label_uploading": "Uploading...",
    "label_main_image_thumb": "Main",
    "label_cannot_set_primary": "Cannot set primary image.",
    "label_kp_confirm_update": "Are you sure you want to update the KP ad?",
    "label_kp_confirm_park": "Are you sure you want to park the KP ad?",
    "label_kp_confirm_unpark": "Are you sure you want to activate the KP ad?",
    "label_kp_confirm_delete": "Are you sure you want to delete the KP ad?",
    "label_kp_share_url_copied": "URL copied.",
    "label_kp_share_url_missing": "Share URL is empty.",
    "label_kp_gallery_panel": "KP + Gallery",
    "label_kp_section_title": "KupujemProdajem",
    "label_kp_ad_id": "KP Ad ID",
    "label_kp_share_url": "Share URL",
    "label_kp_click_to_copy": "Click to copy",
    "label_kp_copy": "Copy",
    "label_kp_loading_categories": "Loading categories...",
    "label_kp_loading_groups": "Loading groups...",
    "label_kp_category": "Category",
    "label_kp_group": "Group",
    "label_kp_group_suggest_text": "Group suggest text",
    "label_kp_type": "Type",
    "label_kp_condition": "Condition",
    "label_kp_price": "Price",
    "label_kp_currency": "Currency",
    "label_kp_price_text": "Price text",
    "label_kp_contact_placeholder": "Contact",
    "label_kp_post_date": "Posted date",
    "label_kp_ad_age": "Ad age",
    "label_kp_more_details": "More details",
    "label_kp_less_details": "Less details",
    "label_kp_immediate_available": "Immediate available",
    "label_kp_exchange": "Exchange",
    "label_kp_price_fixed": "Price fixed",
    "label_kp_local_pickup": "Local pickup",
    "label_kp_courier_delivery": "Courier delivery",
    "label_kp_description_html": "Description (HTML)",
    "label_kp_editor_bold": "Bold",
    "label_kp_editor_italic": "Italic",
    "label_kp_action_publish_loading": "Publishing ad...",
    "label_kp_action_update_loading": "Updating ad...",
    "label_kp_action_park_loading": "Parking ad...",
    "label_kp_action_unpark_loading": "Activating ad...",
    "label_kp_action_unlink_loading": "Unlinking ad...",
    "label_kp_action_delete_loading": "Deleting ad...",
    "label_kp_action_processing": "Processing...",
    "label_kp_publish": "Publish on KP",
    "label_kp_update": "Update ad",
    "label_kp_park": "Park ad",
    "label_kp_unpark": "Activate ad",
    "label_kp_unlink": "Unlink from KP",
    "label_kp_delete": "Delete KP ad",
    "label_upload_failed": "Upload failed.",
    "label_are_you_sure_delete_image": "Are you sure you want to delete the image?",
    "label_delete_image_failed": "Deleting image failed.",
    "label_save_image_order": "Save image order",
    "label_image_order_saved": "Image order saved.",
    "label_image_order_save_failed": "Failed to save image order.",
    "label_download_all_images_zip": "Download all images (ZIP)",
    "label_click_image_to_zoom": "Click image to zoom",
    "label_kp_save_article_before_publish": "Save article before KP publish.",
    "label_kp_publish_success": "KP ad has been published.",
    "label_kp_publish_error": "Error while publishing KP ad.",
    "label_kp_save_article_before_update": "Save article before KP update.",
    "label_kp_update_success": "KP ad has been updated.",
    "label_kp_update_error": "Error while updating KP ad.",
    "label_kp_park_success": "KP ad has been parked.",
    "label_kp_park_error": "Error while parking KP ad.",
    "label_kp_unpark_success": "KP ad has been activated.",
    "label_kp_unpark_error": "Error while activating KP ad.",
    "label_kp_delete_success": "KP ad has been deleted.",
    "label_kp_delete_error": "Error while deleting KP ad.",
    "label_kp_confirm_unlink": "This removes only KP data from our database. The ad on KP stays active. Continue?",
    "label_kp_unlink_success": "KP data has been removed locally.",
    "label_kp_unlink_error": "Error while unlinking KP data.",
    "label_kp_fill_after_create_question": "Do you want to fill KP data now?",
    "label_kp_fill_now": "Fill KP",
    "label_kp_post_new": "Post new ad",
    "label_kp_import": "Pull",
    "label_kp_import_id_only": "Import ID only",
    "label_kp_import_loading": "Pulling...",
    "label_kp_import_required": "KP ID is required.",
    "label_kp_import_invalid": "KP ID must be a positive number.",
    "label_kp_import_success": "KP ad imported successfully. Images synced",
    "label_kp_import_id_only_success": "KP ID linked successfully. Data and images were not imported.",
    "label_kp_import_error": "Error while importing KP ad.",
    "label_kp_kind_goods": "Goods",
    "label_kp_kind_service": "Service",
    "label_kp_kind_job": "Job",
    "label_kp_type_sell": "Sell",
    "label_kp_type_buy": "Buy",
    "label_kp_condition_new": "New",
    "label_kp_condition_as_new": "As new",
    "label_kp_condition_used": "Used",
    "label_kp_condition_damaged": "Damaged",
    "label_cancel": "Cancel",
    "label_success_delete_notification": "Notification successfully deleted",
    "label_add_term": "Add term",
    "label_see_terms": "View terms",
    "label_search": "Search",
    "label_amount_terms": "Total terms",
    "label_amount_trainings": "Total members",
    "label_show_my_trainings": "Show only my trainings",
    "label_name": "Name",
    "label_surname": "Surname",
    "label_date": "Date",
    "label_time": "Time",
    "label_number_of_trainings": "Number of trainings",
    "label_number_of_not_arrived": "Number of no-shows",
    "label_equipment": "Equipment",
    "label_success_add_training": "Training successfully reserved.",
    "label_success_remove_training": "Training successfully canceled.",
    "label_remove_training_title": "Canceling training",
    "label_remove_training_title_are_you_sure": "Do you want to cancel the training?",
    "label_back_training": "Return training",
    "label_back_training_are_you_sure": "Do you want to return the training to the user?",
    "label_save": "Save",
    "label_save_order": "Save order",
    "label_drop_here": "Drop here",
    "label_set_key": "Set key",
    "label_success_add_to_waiting_list": "Successfully added to the waiting list.",
    "label_success_remove_to_waiting_list": "Successfully removed from the waiting list.",
    "label_remove_waiting_list": "Cancel waiting list",
    "label_remove_waiting_list_are_you_sure": "Do you want to cancel the waiting list?",
    "label_my_trainings": "My trainings",
    "label_scheduled_trainings": "Scheduled trainings",
    "label_no_scheduled_trainings": "No scheduled trainings",
    "label_waiting_list": "Waiting list",
    "label_waiting_list_is_empty": "Waiting list is empty",
    "label_see_all_trainings": "Items",
    "label_view_terms_for_day": "View terms for",
    "label_day": "Day",
    "label_training_type": "Type",
    "label_training_type_title": "Training type",
    "label_max_people": "Maximum people",
    "label_reserve_training": "Reserve training",
    "label_edit": "Edit",
    "label_delete": "Delete",
    "label_deactivate": "Deactivate",
    "label_activate": "Activate",
    "label_reserve": "Reserve",
    "label_are_you_sure_activate_term": "Are you sure you want to activate the term",
    "label_are_you_sure_deactivate_term": "Are you sure you want to deactivate the term",
    "label_are_you_sure_delete_term": "Are you sure you want to delete the term",
    "label_term_activated": "Term successfully activated",
    "label_term_deactivated": "Term successfully deactivated",
    "label_term_deleted": "Term successfully deleted",
    "label_edit_term": "Edit term",
    "label_term_success_updated": "Term successfully updated.",
    "label_term_success_saved": "Term successfully added.",
    "label_send_notification": "Send notification",
    "label_add_user_to_term": "Add user to training",
    "label_user_will_be_added_to_term": "will be added to this term ",
    "label_some_user_expire_payment": "For some users, membership has expired. You must first renew the membership.",
    "label_choose_user": "Choose user",
    "label_search_users": "Search users...",
    "label_username": "Username",
    "label_select": "Select",
    "label_click_to_select_user": "Click to select a user",
    "label_pagination_first": "first",
    "label_pagination_previous": "previous",
    "label_pagination_next": "next",
    "label_pagination_last": "last",
    "label_pagination_amount": "Total items",
    "label_from": "From",
    "label_to": "To",
    "label_do_search": "Search",
    "label_show_weekly_report": "Show Weekly Report",
    "label_amount": "Total",
    "label_currency": "RSD",
    "label_number_of_terms": "Number of Terms",
    "label_average": "Average",
    "label_rest_trainings": "Remaining Trainings",
    "label_partner": "Partner",
    "label_add_user": "Add User",
    "label_users_show_only_debtor": "Show Only Debtors",
    "label_users_amount": "Total Users",
    "label_serial_num": "Serial Number",
    "label_paid": "Paid",
    "label_paid_from": "Valid from",
    "label_expire": "Expiration",
    "label_payment_type": "Payment Type",
    "label_are_you_sure_to_delete_user": "Are you sure you want to delete the user",
    "label_user_deleted_success": "User successfully deleted",
    "label_are_you_sure_to_add_training_to_user": "Are you sure you want to add training to the user",
    "label_are_you_sure_to_remove_training_to_user": "Are you sure you want to remove training from the user",
    "label_training_removed_success": "Training successfully removed",
    "label_training_add_success": "Training successfully added",
    "label_email": "Email",
    "label_phone": "Phone",
    "label_close": "Close",
    "label_rest_of_trainings": "Remaining Trainings",
    "label_choose_trainings": "Choose Trainings",
    "label_role": "Role",
    "label_role_user": "User",
    "label_role_trainer": "Trainer",
    "label_role_admin": "Admin",
    "label_choose": "Choose",
    "label_current": "Current",
    "label_delete_trainer": "Delete",
    "label_user_added": "User added",
    "label_user_edited": "User updated",
    "label_update_user": "Update User",
    "label_reset_password": "Reset Password",
    "label_see_payments": "View Payments",
    "label_are_you_sure_to_reset_password_to_user": "Are you sure you want to reset the password for the user",
    "label_password_update": "Password successfully updated",
    "label_picture": "Picture",
    "label_add_payment": "Add payment",
    "label_payment_date": "Payment date",
    "label_payment_expire_date": "Payment expiration date",
    "label_payment_num_trainings": "Number of trainings",
    "label_payment_type_trainings": "Training type",
    "label_payment_money": "Price",
    "label_payment_link_invoice": "Invoice link",
    "label_payment_for_company": "Payment for company",
    "label_payment_equipment": "Equipment",
    "label_payment_error_choose_type": "Choose training type",
    "label_payment_success_add": "Payment successfully added",
    "label_payment_success_edit": "Payment successfully edited",
    "label_edit_payment": "Edit payment",
    "label_add_equipment": "Add new equipment",
    "label_training_type_add": "Add new type",
    "label_payment_for": "Payment for",
    "label_payment_loyalty": "Loyalty",
    "label_payment_add_new": "Add payment",
    "label_payment_are_you_sure_to_delete": "Are you sure you want to delete the payment?",
    "label_edit_account": "Edit account",
    "label_success_edit_profile": "Profile data successfully edited.",
    "label_are_you_sure_to_delete_account": "Are you sure you want to delete the account? You can recover your account by logging in again.",
    "label_success_deleted": "Account successfully deleted",
    "label_success_extend_payment": "Membership successfully extended.",
    "label_active_payment": "Active membership",
    "label_history_payment": "Payment history",
    "label_active_payment_expire": "Membership valid until",
    "label_active_payment_price": "Payment",
    "label_active_payment_tr_numbers": "Number of paid trainings",
    "label_active_payment_type": "Training type",
    "label_active_payment_rest": "Remaining",
    "label_extend_payment": "Extend membership",
    "label_history_payment_from": "Valid from",
    "label_history_payment_to": "to",
    "label_show_invoice": "Show invoice",
    "label_edit_profile": "Edit profile",
    "label_change_password": "Change password",
    "label_delete_account": "Delete account",
    "label_delete_account_success": "Account successfully deleted",
   "label_term_title": "Predefined terms",
   "label_open_term": "Open terms",
   "label_add_new_type_trainings": "Add new training type",
   "label_delete_searched_terms": "Delete found terms",
   "label_created_by": "Created by",
   "label_are_you_sure_delete_found_terms": "Are you sure you want to delete the found terms?",
   "label_terms_deleted_success": "Terms successfully deleted",
   "label_term_deleted_success": "Term successfully deleted",
   "label_add_notification": "Add notification",
   "label_notification_priority": "Priority",
   "label_notification_low": "Low",
   "label_notification_medium": "Medium",
   "label_notification_high": "High",
   "label_link": "Link",
   "label_choose_days": "Choose days",
   "label_term_add_user_to_term": "Add user to term",
   "label_term_user_will_be_added": "will be added to this term",
   "label_term_choose_at_least_day": "You must choose at least one day.",
   "label_term_added_success": "Term successfully added",
   "label_term_edit_term": "Edit term",
   "label_term_edit_term_success": "Successfully edited term",
   "label_open_trainings_for": "Open trainings for",
   "label_open_trainings_for_desc": "If you leave the date empty, terms will be created for",
   "label_open_trainings_success": "Training terms successfully opened",
   "label_count_payments": "Number of payments",
   "label_add_partner": "Add",
   "label_name_of_partner": "Partner's name",
   "label_partner_add_title": "Add partner",
   "label_partner_edit_title": "Edit partner",
   "label_partner_all_field_required": "Field must not be empty",
   "label_old_password": "Old Password",
   "label_new_password": "New Password",
   "label_repeat_password": "Repeat Password",
   "label_password_error_not_empty": "New password cannot be empty",
   "label_password_error_old_password_not_empty": "Old password cannot be empty",
   "label_password_error_repeat_same_password": "Repeat the same password",
   "label_password_success_changed": "Password successfully changed",
   "label_password": "Password",
   "label_do_login": "Log In",
   "label_no_data_trainings": "There are no slots for selected date",
   "label_no_membership": "There is no active memebership",
    "label_no_membership_history": "There is no history payments",
    "label_input_serbian": "Insert text on default language",
    "label_input_title_serbian": "Insert title on default language",
    "label_input_english": "Insert text on English (optional)",
    "label_input_title_english": "Insert title on English (optional)",
    "label_load_image": "Load image",
    "label_edit_picture": "Edit image",
    "label_max_size_picture": "Max size for image is 5MB",
    "label_image_upload_error": "Error while uploading image.",
    "label_edit_notification": "Edit notification",
    "label_notification_empty": "Notification can't be empty!",
    "label_notification_title_empty": "Title of notification can't be empty!",
    "label_notification_add_success": "Notification added successfully",
    "label_notification_edit_success": "Notification edited successfully",
    "label_open_terms_for_current_week": "Open terms for current week",
    "label_training_history": "Training history",
    "label_training_history_is_empty": "Training history is empty",
    "label_created_edited": "Created/Edited by",
    "label_user_training_type": "Type payment",
    "label_training_key": "Add Key",
    "label_add_key": "Add Key",
    "label_max_people_on_training": 'Number people on training',
    "label_name_for_partner": 'trainer',
    "label_mp_title": 'Membership Packages',
    "label_mp_name": 'Package Name',
    "label_mp_add": 'Add Package',
    "label_mp_during_in_days": 'Package Duration in Days',
    "label_mp_price": 'Package Price',
    "label_membership_are_you_sure_to_delete": 'Are you sure you want to delete the package?',
    "label_birthday": 'Birthday',
    "label_payment_paid_date": 'Payment date',
    "label_loyalty": 'Loyalty',
    "label_success_delete_payment": "Successfully deleted payment",
    "label_buy_membership": "Buy membership",
    "label_buy_membership_from_date": "Buy membership from date",
    "label_please_select_date": "Please select the start date of the membership validity",
    "label_success_bought_membership": "You have successfully purchased a membership.",
    "label_current_busy": "Current rush in the gym",
    "label_invoices": "Invoices",
    "label_invoices_created_successfully": "Invoice(s) successfully created",
    "label_created": "Created",
    "label_paid_yes": "Yes",
    "label_paid_no": "No",
    "label_number_user_for_invoice": "Users billed",
    "label_set_paid": "Mark as paid",
    "label_current_balance": "Current credit balance",
    "label_invoice_are_you_sure_to_delete": "Are you sure you want to delete the invoice?",
    "label_add_invoice": "Add Invoice",
    "label_invoice_create_all_confirm": "Are you sure you want to generate invoices for all companies?",
    "label_invoice_item_price": "Item Price",
    "label_invoice_item_count": "Quantity",
    "label_invoice_type": "Invoice Type",
    "label_invoice_all_field_required": "All fields are required",
    "label_add_invoice_all": "Generate invoices for all",
    "label_invoice_report": "Invoice report",
    "label_monthly_turnover": "Monthly turnover",
    "label_turnover_by_company": "Turnover by company",
    "label_total_turnover": "Total turnover",
    "label_debtors": "Debtors",
    "label_debtors_list": "Debtors list",
    "label_no_minus_invoices_for_period": "No minus invoices for selected period",
    "label_no_permission_for_report": "You do not have permission for this report",
    "label_download_pdf": "Download PDF",
    "label_pdf": "PDF",
    "label_category_membership": "Category (optional)",
    "label_add_category_membership": "Add new category",
    "label_insert_name_category_membership": "Enter category name",
    "label_mp_category": "Category",
    "label_ci_training_add": "Add new training",
    "label_ci_training_name": "Training name",
    "label_ci_training_name_en": "Training name (en)",
    "label_ci_training_short_desc": "Short description",
    "label_ci_training_short_desc_en": "Short description (en)",
    "label_ci_training_long_desc": "Long description",
    "label_ci_training_long_desc_en": "Long description (en)",
    "label_ci_training_image": "Image",
    "label_ci_training_choose_image": "Choose image",
    "label_ci_training_kcal": "Calories burned",
    "label_ci_training_minutes": "Duration of training in minutes",
    "label_ci_training_intensity": "Training intensity (0 - 5)",
    "label_ci_training_required": "Required: name, short description, long description, image",
    "label_ci_training_success_add": "Training successfully added",
    "label_ci_training_are_you_sure": "Are you sure you want to delete: ",
    "label_trainers": "Trainers",
    "label_ci_trainer_add": "Add new trainer",
    "label_user_added_success_add_payment": "User successfully added! Would you like to add their first payment?",
    "label_set_trainings_number": "Set the number of trainings",
    "label_ci_nutrition_add": "Add new item",
    "label_ci_nutrition": "Blog",
    "label_ci_nutrition_name": "Item name",
    "label_ci_nutrition_name_en": "Item name (en)",
    "label_ci_nutrition_short": "Short description",
    "label_ci_nutrition_short_en": "Short description (en)",
    "label_ci_nutrition_long": "Longer description",
    "label_ci_nutrition_long_en": "Longer description (en)",
    "label_articles": "Articles",
    "label_on_waiting": "On waiting",
    "label_amount_articles": "Total number of articles",
    "label_a_name": "Name",
    "label_a_category": "Category",
    "label_a_sub_category": "Subcategory",
    "label_a_memory": "Memory",
    "label_a_purchase_price": "Purchase price",
    "label_a_selling_price": "Selling price",
    "label_a_desc": "Description",
    "label_a_comment": "Comment",
    "label_add_article": "Add article",
    "label_a_stock": "Quantity",
    "label_a_statuses": "Status",
    "label_a_statuses_show": "Show actions",
    "label_article_added": "Article successfully added",
    "label_article_updated": "Article successfully updated",
    "label_a_stock_number": "Quantity",
    "label_a_stock_number_set": "Set quantity",
    "label_update_article": "Update article",
    "label_are_you_sure_to_remove_article": "Are you sure you want to delete the article?",
    "label_are_you_sure_to_remove_category": "Are you sure you want to delete the category?",
    "label_article_removed_success": "Article deleted",
    "label_a_code": "Code",
    "label_a_c_add": "Add categories",
    "label_a_c_add_sub_for": "Add subcategory for",
    "label_a_c": "Categories",
    "label_a_c_sub": "Subcategory",
    "label_a_c_see_sub": "See subcategories",
    "label_back_to_all_categories": "Back to all categories",
    "label_show_filters": "Show filters",
    "label_clear_filters": "Clear filters",
    "label_a_c_edit_sub_for": "Edit subcategory for ",
    "label_a_c_name": "Add category ",
    "label_choose_imei": "Choose IMEI",
    "label_crop_image": "Crop code",
    "label_article_approve": "Approve",
    "label_article_approved_success": "Successfully approved",
    "label_are_you_sure_to_approve_article": "Are you sure to wanna approve  ",
    "label_article_all": "All",
    "label_article_for_approve": "For Approval",
    "label_article_active": "Active",
    "label_article_service": "In Service",
    "label_article_sold": "Sold",
    "label_article_waiting_approve": "Waiting Approval",
    "label_imei_error": "IMEI must have exactly 15 digits",
    "label_serial_number_error": "Should not be empty",
    "label_are_you_sure_to_add_to_stock": "Are you sure you want to add to stock ",
    "label_are_you_sure_to_remove_to_stock": "Are you sure you want to remove from stock ",
    "label_article_add_to_stock": "Add to stock",
    "label_article_remove_to_stock": "Sold",
    "label_buy_date": "Purchase Date",
    "label_article_already_exist": "Article already exists",
    "label_article_are_you_sure_update_already": "Do you want to update the existing article?",
    "label_ci_shop": "Shop",
    "label_ci_shop_add": "Add product",
    "label_ci_shop_name": "Product name",
    "label_ci_shop_name_en": "Product name (en)",
    "label_ci_shop_short_desc": "Short description",
    "label_ci_shop_short_desc_en": "Short description (en)",
    "label_ci_shop_long_desc": "Long description",
    "label_ci_shop_long_desc_en": "Long description (en)",
    "label_ci_shop_success_add": "Product successfully added.",
    "label_ci_shop_price": "Price",
    "label_ci_shop_currency": "Currency",
    "label_ci_mobile_settings": "Application",
    "label_ci_header_image": "Header image on the application's home page",
    "label_ci_header_image_uploaded_success": "Header image uploaded.",
    "label_ci_header_photo_delete_are_you_sure": "Are you sure you want to remove the header image from the application?",
    "label_ci_header_image_deleted_success": "Header image deleted.",
    "label_ci_header_image_info_desc_1": "Header image for the application",
    "label_ci_header_image_info_desc_2": "This image will be displayed to users on the home page.",
    "label_a_color": "Color",
    "label_internal_code": "Internal code",
    "label_search_internal_code": "Search by Internal code",
    "label_see_colors": "See colors",
    "label_category_name": "Name",
    "label_add_new_color": "Add new color",
    "label_show_personal_message": "Show personalized messages",
    "label_show_personal_message_desc": "If you select a type, only users who have that type marked during payment will see this notification",
    "label_show_sort": "Sorting",
    "label_clear_sort": "Hide sorting",
    "label_sort_by_date": "Sort by date",
    "label_sort_by_abs": "Sort alphabetically",
    "label_ci_trainer_name": "Trainer's name",
    "label_ci_trainer_name_en": "Trainer's name (en)",
    "label_a_ram_memory": "RAM memory",
    "label_article_sent_by_post": "Sent by post",
    "label_show_more": "Show more",
    "label_show_less": "Show less",
    "label_not_active_more": "Inactive for longer than",
    "label_not_active_more_3": "3 months",
    "label_not_active_more_6": "6 months",
    "label_price": "Price",
    "label_success_update_waiting_list": "Successfully updated waiting list",
    "label_show_users_more": "Show",
    "label_expire_payment_users": "Show users whose membership has expired",
    "label_active_users": "Active users",
    "label_active_users_last_30_days": "Active users last 30 days",
    "label_not_active_users": "Inactive users",
    "label_article_archived": "Archived",
    "label_are_you_sure_to_recovery_article": "Are you sure you want to recover the article",
    "label_article_recovered_success": "Article recovered successfully",
    "label_recovery": "Recover",
    "label_ci_shop_discount": "Discount",
    "label_ci_position": "Position in List",
    "label_ci_position_desc": "If you leave 0 in this field, the item will be added as the last in the list",
    "label_standard_payment": "Standard payment",
    "label_additional_payment": "Additional services",
    "label_payment_types": "Payment types",
    "label_activate_all": "Activate all",
    "label_activate_all_desc": "Do you want to activate all terms?",
    "label_deactivate_all": "Deactivate all",
    "label_deactivate_all_desc": "Do you want to deactivate all terms?",
    "label_format_of_time_not_valid": "Time format must be as follows: HH:mm (e.g., 12:20)",
    "label_term_choose_at_least_time": "You must add at least one time. Add time by first entering the desired time and then clicking on the + on the right side.",
    "label_important": "Important",
    "label_qr_code_training_type": "QR code entry",
    "label_approved": "Approved",
    "label_approve": "Approve",
    "label_approve_are_you_sure": "Are you sure you want to approve the training for:",
    "label_success_approved_training": "Training successfully approved",
    "total_debt": "Total debt",
    "label_activate_all_filtered": "Activate found",
    "label_deactivate_all_filtered": "Deactivate found",
    "label_deactivate_all_desc_filtered": "Do you want to deactivate the found slots?",
    "label_activate_all_desc_filtered": "Do you want to activate the found slots?",
    "label_delete_and_cancel_all_users": "Delete and cancel all trainings",
    "label_success_added_user": "Successfully added user",
    "label_success_qr_code_scan": "Successful login via QR code",
    "label_success_qr_code_scan_title": "Successful login",
    "label_success_qr_code_approve": "Successful approval via QR code",
    "label_success_qr_code_approve_title": "Successful confirmation",
    "label_user": "User",
    "label_expire_payment_for_user": "Membership Expired",
    "label_shop_link": "Link from shop",
    "label_entrance": "QR Entrance",
    "label_entrance_success_reserved": "Successfully scanned code",
    "label_a_code_serial": "Serial number",
    "label_desc_training_filter_on_report": "*Note: the selected time slot from the list only applies to the chosen start date",
    "label_choose_location": "Choose a location: ",
    "label_choose_location_desc": "*Note: if you do not choose any location, the item will be visible at all locations",
    "label_quantity_for_buy": "Quantity for purchase",
    "label_quantity_for_buy_desc": "*number of items the user will buy, e.g.: you are selling 3 chocolate bars at a discounted price, then you enter 3 here",
    "label_buy": "Buy",
    "label_order": "Order",
    "label_are_you_sure_buy_item": "Are you sure you want to buy the item: ",
    "label_successfully_bought_item": "Item successfully purchased. You can check the status of the item in your wallet.",
    "label_are_you_sure_order_item": "Are you sure you want to order the item: ",
    "label_successfully_ordered_item": "Item successfully ordered. You can check the status of the item in your wallet.",
    "label_tab_orders": "Orders",
    "label_orders_bought": "Purchased items",
    "label_orders_used": "Used items",
    "label_are_you_sure_cancel_order": "Are you sure you want to cancel the order: ",
    "label_order_canceled_successfully": "Are you sure you want to cancel the order: ",
    "label_user_wallet_quantity": "Quantity to spend",
    "label_user_wallet_used": "Used",
    "label_shop_qr": "QR code",
    "label_shop_qr_list": "QR list",
    "label_enter_fullscreen": "Enter full screen",
    "label_exit_fullscreen": "Exit full screen",
    "label_fullscreen_failed": "Cannot switch full screen mode.",
    "label_are_you_sure_pay_user_wallet": "Are you sure you want to confirm the payment: ",
    "label_user_wallet_paid_successfully": "Payment successfully completed",
    "label_action": "Action",
    "label_action_for_item": "Action for item",
    "label_ci_shop_edit": "Edit item",
    "label_personal": "Personal",
    "label_wod": "WOD",
    "label_wod_program_display_error": "Unable to display the program. Please try again later.",
    "label_add_td": "Add new training",
    "label_td_name": "Training name",
    "label_td_name_en": "Training name (en)",
    "label_td_short_desc": "Short description",
    "label_td_short_desc_en": "Short description (en)",
    "label_td_long_desc": "Long description",
    "label_td_long_desc_en": "Long description (en)",
    "label_delete_training_of_the_day_successfully": "Training successfully deleted",
    "label_delete_training_of_the_day": "Delete training",
    "label_delete_training_of_the_day_are_you_sure": "Are you sure you want to delete the training",
    "label_success_added_training_of_the_day": "Training successfully added",
    "label_choose_exist_training": "Choose existing training",
    "label_search_trainings_definition": "Search trainings",
    "label_edit_td": "Edit training",
    "label_success_edited_training_of_the_day": "Training successfully edited",
    "label_td_name_required": "Name is required",
    "label_all_wod_trainings": "Overview of all trainings",
    "label_all_personal_trainings": "Overview of all exercises",
    "label_all_wod_trainings_title": "Overview of all WOD trainings",
    "label_search_personal_trainings_definition": "Search exercises",
    "label_add_new_pt_exercise": "Add new exercise",
    "label_td_pt_name": "Exercise name",
    "label_td_pt_video": "Video link",
    "label_td_pt_name_en": "Exercise name (en)",
    "label_td_pt_short_desc": "Short description",
    "label_td_pt_short_desc_en": "Short description (en)",
    "label_td_pt_long_desc": "Long description",
    "label_td_pt_long_desc_en": "Long description (en)",
    "label_video": "Video",
    "label_add_new_personal_program": "Add new program",
    "label_personal_title": "Personal program",
    "label_pp_active": "Active programs",
    "label_pp_not_active": "Inactive programs",
    "label_pp_predefined_programs": "Predefined programs",
    "label_pp_name": "Program name",
    "label_pp_name_en": "Program name (en)",
    "label_pp_from_date": "Program duration from",
    "label_pp_from_to": "Program duration to",
    "label_pp_choose_user": "Select user for the program",
    "label_pp_choose_user_or_partner": "Select a user or an external partner",
    "label_pp_success_saved": "Program successfully saved",
    "label_pp_user_to_be_added": "will be added to the program",
    "label_pp_add_user_to_program": "Select user for the program",
    "label_delete_personal_program": "Delete program",
    "label_delete_personal_program_are_you_sure": "Are you sure you want to delete the program",
    "label_delete_personal_program_successfully": "Program successfully deleted",
    "label_edit_exercise": "Edit exercises",
    "label_edit_personal_program": "Edit program",
    "label_pp_title": "Personal program",
    "label_all_the_exercises": "View all exercises",
    "label_not_include_in_program": "Not included",
    "label_my_active_program": "Current programs",
    "label_amount_purchase_price": "Total purchase price",
    "label_wod_type_training": "Type",
    "label_wod_category_training": "Category",
    "label_wod_coach_notes": "Coach's Note",
    "label_td_type": "Type",
    "label_td_category": "Category",
    "label_td_add_category": "Add category",
    "label_td_add_category_insert_name": "Enter the name of the new category",
    "label_td_add_category_save_name": "Save new category",
    "label_td_category_choose": "Choose category",
    "label_td_category_choosed_delete": "Delete chosen category",
    "label_company_partners": "External partners",
    "label_number_of_people_for_company": "Maximum users",
    "label_are_you_sure_delete_partner": "Are you sure?",
    "label_are_you_sure_delete_partner_desc": "Are you sure you want to delete",
    "label_partner_success_delete": "Successfully deleted.",
    "label_copy_program": "Copy program",
    "label_copy_program_action": "Copy",
    "label_assign_program_action": "Assign",
    "label_without_company_partners": "No external partner",
    "label_personal_user": "User",
    "label_personal_company": "Company",
    'label_download_qr_code': 'Download as image',
    'label_pt_other_category': 'Other',
    'label_user_type_online': 'Online user',
    'label_user_type_training_center': 'Training center',
    'label_user_type_both': 'Online and training center',
    'label_user_type': 'User type',
    "label_no_workouts": "No workouts are currently set",
    "label_no_active_programs": "No active program at the moment",
    "label_view": "View program",
    'label_download_report': 'Download report',
    'label_user_credit': 'CashBack Credits',
    'label_add_credits': 'Add Credits',
    'label_take_credits': 'Deduct Credits',
    'label_mp_action': 'Is the package on sale?',
    'label_choose_company': 'Choose your company',
    'label_documentations': 'Documentations',
    "label_td_results_config": "Results Configuration",
    "label_td_add_measure_insert_name": "Enter Measure Name",
    "label_td_add_result_measure": "Add New Measure",
    "label_td_measure_choose": "Choose Measure",
    "label_td_result_rounds": "Number of Rounds",
    "label_td_measure_choosed_delete": "Delete Selected Measure",
    "label_result_repeat": "No. of Repetitions",
    "label_result_set": "Set",
    "label_completed": "Completed",
    "label_change_my_result": "Insert",
    "label_see_all_results": "All Results",
    "label_wod_results": "Results",
    "label_see_wod_as_user": "View WOD as User",
    "label_training_type_are_you_sure_to_delete": "Are you sure you want to delete",
    "label_success_update_training_types": "Training Types Successfully Updated",
    "label_training_types": "Training Types",
    "label_trainer_name": "Trainer",
    'label_credit_active': 'Active',
    'label_credit_history': 'Expired',
    'label_credit_used': 'Used',
    'label_are_you_sure_delete_user_credit': 'Are you sure?',
    'label_are_you_sure_delete_user_credit_desc': 'Are you sure you want to delete the credit?',
    'label_is_this_credit_type': 'Is this credit? (If the user buys this, it will be added to their credit balance)',
    'label_shoes_size': 'Shoe size',
    'label_us_type': 'Credit type',
    'label_us_amount': 'Credit amount',
    'label_us_amount_used': 'Credit usage',
    'label_us_created_date': 'Created date',
    'label_us_valid_to': 'Valid until',
    'label_lesson_url': 'Lesson link',
    'label_user_additional_info': 'Additional user information',
    'label_home_trainings': 'Programs',
    'label_wod_total_result': 'Options for total result',
    'label_td_total_result_choose': 'Choose value',
    'label_wod_total_result_min': 'Minimum',
    'label_wod_total_result_max': 'Maximum',
    'label_wod_total_result_average': 'Average',
    'label_wod_total_result_sum': 'Sum',
    'label_wod_result_sort': 'Result sorting method',
    'label_wod_result_sort_asc': 'Ascending (smallest is best)',
    'label_wod_result_sort_desc': 'Descending (largest is best)',
    'label_total_result': 'Final result',
    'label_hide_details': 'Show less',
    'label_show_details': 'Show more',
    "label_gender": "Gender",
    "label_gender_male": "Male",
    "label_gender_female": "Female",
    "label_choose_gender": "Choose gender for search",
    'label_gender_man': 'Men',
    'label_gender_woman': 'Women',
    "label_copy_rd": "Copy day",
    "label_copy_training_desc": "Select dates for which you want to copy the training",
    "label_selected_dates": "Selected dates",
    "label_success_copy_trainings": "Successfully copied trainings",
    'label_ci_events': 'Events',
    'label_ci_event_add': 'Add event',
    'label_ci_item_name': 'Name',
    'label_ci_item_name_en': 'Name (en)',
    'label_ci_item_short_desc': 'Short description',
    'label_ci_item_short_desc_en': 'Short description (en)',
    'label_ci_item_long_desc': 'Long description',
    'label_ci_item_long_desc_en': 'Long description (en)',
    'label_ci_item_success_add': 'Item successfully added',
    'label_ci_event_sign_up': 'Sign up',
    'label_ci_event_sign_up_edit': 'Edit',
    'label_ci_event_fields': 'Required information',
    'label_ci_event_fields_add_new': 'Enter new information',
    'label_ci_event_fields_add': 'Add',
    'label_ci_event_all_users': 'All registrations',
    'label_event_info': 'Additional information',
    'label_ci_max_signups': 'Maximum signups',
    'label_ci_event_successfully_sign_up': 'Successful signup',
    'label_payment_comment': 'Notes',
    "label_filter_day": "day",
    "label_filter_week": "week",
    "label_filter_month": "month",
    "label_filter_show": "Show",
    "label_user_note_add": "Add to journal",
    "label_user_note_edit": "Edit note",
    "label_user_note_delete_desc": "Are you sure you want to delete the note?",
    'label_schedule': 'Shifts',
    'label_budget': 'Budget',
    'label_schedule_start': 'Start shift',
    'label_schedule_insert_money': 'Assign money',
    'label_schedule_inserted_money': 'Assigned',
    'label_schedule_are_you_sure_to_delete': 'Are you sure you want to delete the shift?',
    'label_success_delete_schedule': 'Shift successfully deleted',
    'label_schedule_out_money': 'Handed over money',
    'label_status': 'Status',
    'label_schedule_active': 'Open',
    'label_schedule_finished': 'Closed',
    'label_schedule_lock': 'Confirmed closure',
    'label_approve_schedule_title': 'Confirm shift',
    'label_approve_schedule': 'Confirm',
    'label_close_schedule_title': 'Close shift',
    'label_close_schedule': 'Close',
    'label_schedule_inserted_money_current': 'Current',
    'label_schedule_item_cost': 'Cost/profit',
    'label_plus': 'Plus',
    'label_minus': 'Minus',
    'label_amount_in': 'Amount in',
    'label_article_for_change': 'Item serial number for replacement (6 digits)',
    'label_insert_profit': 'Enter profit',
    'label_comment': 'Comment',
    'label_additional_cost_in': 'Additional cost in',
    'label_download_training_data': 'Download report',
    'label_training_report_title': 'Training report',
    "label_additional_costs": "Additional costs",
    "label_schedule_are_you_sure_to_approve": "Are you sure you want to approve the shift?",
    "label_success_approved_schedule": "Shift successfully approved",
    "label_edit_schedule_title": "Edit shift",
    "label_add_amount": "Add amount",
    "label_remove_amount": "Remove amount",
    "label_article_for_change_title": "Article for exchange (optional)",
    "label_send_message": "Message content",
    "label_title_message": "Campaign title",
    "label_enter_email_title": "Enter message title",
    "label_enter_email_text": "Enter message text",
    "label_send_by_email": "Send via email",
    "label_send_by_notification": "Send as notification",
    "label_send": "Send",
    "label_chat": "Support",
    "label_admin_chat": "Support",
    "label_user_chat": "Support",
    "label_conversations": "Conversations",
    "label_no_conversations": "No conversations",
    "label_messages": "Messages",
    "label_no_messages": "No messages",
    "label_write_message": "Write a message",
    "label_new_message_admin": "Message administrator",
    "label_new_message_trainer": "Message trainer",
    "label_start_chat": "Start chat",
    "label_start_conversation": "Start conversation",
    "label_chat_active": "Active",
    "label_chat_closed": "Closed",
    "label_close_conversation": "Close conversation",
    "label_close_conversation_confirm": "Do you want to close this conversation?",
    "label_chat_load_error": "Unable to load chat. Please try again later.",
    "label_faq": "Frequently asked questions",
    "label_faq_add_new": "Add question",
    "label_faq_question": "Question",
    "label_faq_answer": "Answer",
    "label_faq_order_number": "Order number",
    "label_faq_active": "Active",
    "label_faq_inactive": "Inactive",
    "label_faq_empty": "No questions",
    "label_faq_edit": "Edit question",
    "label_faq_delete_confirm": "Do you want to delete this question?",
    "label_conversation_not_available": "Conversation is not available.",
    "label_admin": "Admin",
    "label_back": "Back",
    "label_selected_users": "Selected users",
    "label_selected_companies": "Selected companies",
    "label_select_all": "Select all",
    "label_unselect_all": "Unselect all",
    "label_hide_filters": "Hide filters",
    "label_reset_filters": "Reset filters",
    "label_enter_email_title_en": "Enter title in English (optional)",
    "label_enter_email_text_en": "Enter message in English (optional)",
    "label_campaign_image_url": "Image URL (optional)",
    "label_campaign_error_no_users_selected": "Please select at least one user",
    "label_campaign_error_no_companies_selected": "Please select at least one company",
    "label_campaign_error_title_required": "Campaign title is required",
    "label_campaign_error_message_required": "Campaign message is required",
    "label_campaign": "Campaign",
    "label_campaign_company": "Company campaign",
    "label_add_campaign": "Create campaign",
    "label_add_company_campaign": "Create company campaign",
    "label_users_number": "Number of users",
    "label_article_in_schedule": "Include in shift",
    "label_open_door": "Open door",
    "label_trainer_report": "Employee Report",
    "label_report_type": "Type",
    "label_report": "Report",
    "label_report_total_slots": "Total Sessions",
    "label_number_slots": "Number of Sessions",
    "label_tab_orders_reservation": "Reserved Products",
    "label_location": "Location",
    "label_time_pickup": "Pickup Time",
    "label_state_in_warehouse": "Warehouse Stock",
    "label_please_select_trainer": "Please select a trainer",
    "label_show_only_free_slots": "Show only available slots",
    "label_do_search_by_slot": "Report by slot",
    "label_do_search_by_user": "Report by user",
    "label_reports": "Reports",
    "label_include_in_schedule": "Include in shift",
    "label_additional_cost": "Cost",
    "label_schedule_profit": "Profit",
    "label_change_profit": "Change profit",
    "label_articles_report": "Report",
    "label_report_summary": "Report summary",
    "label_by_currency": "By currency",
    "label_total_articles": "Total articles",
    "label_margin": "Margin",
    "label_total": "Total",
    "label_article_log_report": "Article activity report",
    "label_article_log_report_hint": "Uses the same From/To filters from the section above.",
    "label_post_on_kp_count": "Posted on KP",
    "label_selling_count": "Sold",
    "label_uploaded_images_for_kp": "Added images for KP",
    "label_article_log_dates_required": "From and To dates are required for this report.",
    "label_article_log_invalid_period": "From date must be less than or equal to To date.",
    "label_c_schedule_user_report": "Profit report by user",
    "label_c_schedule_user_report_hint": "Uses the same From/To filters from the section above.",
    "label_turnover_eur": "Turnover EUR",
    "label_turnover_rsd": "Turnover RSD",
    "label_profit_eur": "Profit EUR",
    "label_are_you_sure_to_show_all": "Do you want to show all",
    "label_end_date": "End date",
    "label_ci_event_edit": "Edit event",
    "label_ci_event_location": "Location",
    "label_ci_event_price": "Price",
    "label_choose_package": "Choose membership",
    "label_view_table": "Table view",
    "label_view_slot": "Show all slots",
    "label_expire_to_days": "expires in ... days",
    "label_download_user_report": "Show report",
    "label_trainer": "Trainer",
    "label_mp_for_program": "Is this a membership for the program?",
    "label_program_buy": "Buy program",
    "label_start_program": "Start program",
    "label_program_filter_all": "All programs",
    "label_program_filter_bought": "Purchased",
    "label_program_filter_free": "Free",
    "label_program_filter_lock": "Locked",
    "label_program_is_free": "Is the program free?",
    "label_program_is_template": "Do you want this to be a predefined program?",
    "label_regular_sell": "Sale",
    "label_regular_supply": "Regular supply",
    "label_pp_short_desc": "Short description",
    "label_pp_short_desc_en": "Short description (en)",
    "label_pp_long_desc": "Long description",
    "label_pp_long_desc_en": "Long description (en)",
    "label_total_price": "Total price",
    "label_returned_amount": "Change",
    "label_schedule_item": "Edit shift item",
    "label_type_active_en": "Open",
    "label_type_closed_en": "Closed",
    "label_type_approved_en": "Approved",
    'label_article_for_change_button': 'Item for exchange',
    'label_color_delete_are_you_sure': 'The color will be deleted from history',
    "delete_color_from_history": 'Delete color forever',
    'label_article_changed': 'New article codes',
    'label_change_for': 'Replacement',
    'label_success_open_door': 'Successfully open door',
    'scanner_control': 'Scanner Control',
    'scanner_focus': 'Scanner is in focus',
    'scanner_not_focus': 'Scanner is NOT in focus',
    'focus_scanner': 'Focus scanner',
    'last_scanned_user': 'Last scanned user',
    'scanning_in_progress': 'Scanning in progress',
    'label_add_on_current_state_trainings': 'Add appointments to the current state?',
    'label_si_all': 'All',
    'label_si_sell': 'Sale',
    'label_si_buy': 'Purchase',
    'label_si_purchase': 'Procurement',
    'label_si_additional_cost': 'Cost',
    "label_timed_slots": "Timed Slots",
    "label_are_you_sure_delete_timed_slot": "Are you sure you want to delete",
    "label_timed_slot_success_delete": "Successfully deleted",
    "label_are_you_sure_checkout_timed_slot": "Are you sure you want to check out",
    "label_timed_slot_name": "Resource Name",
    "label_capacity": "Capacity",
    "label_start": "Start",
    "label_end": "End",
    "label_checkout": "Check Out",
    "label_extend": "Extend",
    "label_no_active_guests": "No active guests.",
    "label_add_new_timed_slot": "Add New Resource",
    "label_capacity_progress": "Occupancy",
    "label_expired": "Expired",
    "label_rest": "Remaining",
    "label_choose_resource_for_check_in": "Choose a resource for user check-in.",
    "label_set_number_in_minutes": "Enter value in minutes",
    "label_extended": "Extended",
    "label_choose_shop_item": "Choose product",
    "label_add_shop_item": "+ product",
    "label_click_to_select_shop_item": "select",
    "label_shop_item": "Product",
    "label_ended": "Checked out",
    "label_finished": "Finished",
    "label_article_is_new": "New article?",
    "label_new_article": "new",
    "label_used_article": "used",
    "label_article_condition": "Condition",
    "label_kp_posted": "KP status",
    "label_kp_posted_yes": "Posted on KP",
    "label_kp_posted_no": "Not posted",
    "label_filter_add_info_memory": "Additional memory (exact)",
    "label_filter_ram_memory": "RAM memory (exact)",
    "label_filter_color_partial": "Color",
    "label_bar_pos": "Bar",
    "label_quick_sell": "Quick sell",
    "label_all": "All",
    "label_bills": "Bills",
    "label_cart": "Cart",
    "label_cart_items": "Items",
    "label_cart_approve": "Approve",
    "label_cart_not_on_stock": "Out of stock",
    "label_cart_added": "Added",
    "label_shop_item_state": "State",
    "label_group_by_user": "Group by user",
    "label_group_by_product": "Group by product",
    "label_sell_product": "Sold",
    "label_nothing_found": "No items",
    "label_loading": "Loading...",
    "label_results": 'Results',
    "label_user_type_personal": 'Personal',
    "label_verify_are_you_sure": "Verify user",
    "label_verify": "Verify",
    "label_registered": "Registered",
    "label_sort_by": "Sort by",
    "label_direction": "Sort direction",
    "label_direction_up": "Ascending",
    "label_direction_down": "Descending",
    "label_created_at": "Registration date",
    "label_last_activity": "Last activity time",
    "label_paid_date": "Payment date",
    "label_expire_date": "Expiration date",
    "label_membership_type": "Payment type visible in the app",
    "label_update_user_profile": "User profile",
    "label_user_profile_details": "Account details",
    "label_user_payment_details": "Payment list",
    "label_add_sign_up_user": "Register user",
    "label_membership_subscription": "Subscription",
    "label_membership_one_payment": "One-time payment",
    "label_membership_both": "Subscription and one-time payment",
    "label_subscriptions": 'Subscriptions',
    "label_created_date": 'Creation date',
    "label_payment_next_charge": 'Next charge',
    "label_number_of_renewal": 'Number of renewals',
    "label_ci_knowledge": "Knowledge Base",
    "label_ci_knowledge_add": "Add Item",
    "label_ci_knowledge_name": "Name",
    "label_ci_knowledge_name_en": "Name (EN)",
    "label_ci_knowledge_embeded_video_link": "Embedded Video Link",
    "label_preview": "Preview",
    "label_copy_to_notification": 'Kopiraj u notifikaciju',
    "label_cash_register": "Cash register",
    "label_cash_current_state": "Current balance",
    "bill_status_finished": "Completed",
    "bill_status_pending": "Pending",
    "label_simple_search": "Simple search",
    "label_advanced_search": "Advanced search",
    "label_create_custom_bill": "Create bill",
    "label_fill_custom_bill": "By creating this bill, the cash register will be increased by the entered amount",
    "label_bill_enter_name": "Enter bill name, e.g. sold specific membership...",
    "label_bill_enter_amount": "Enter bill amount",
    "label_bill_optional_comment": "Enter comment (optional)",
    "label_save_bill": "Save bill",
    "label_cart_description": "Click on a product to add it to the cart",
    "label_cash_cashout": "Cash out",
    "label_fill_required_fields": "Required fields are name, total amount, and category",
    "label_saving": "Please wait",
    "bill_status_from_canceled": "From canceled",
    "bill_status_canceled": "Canceled",
    "label_bill_cancel": "Cancel",
    "label_storn_bill_description": "Are you sure you want to cancel this bill?",
    "label_shop_category_shop": "Shop",
    "label_shop_category_membership": "Membership",
    "label_shop_category_all": "All",
    "label_discount": "Discount",
    "label_insert_discount": "Enter discount (0–100) %",
    "label_amount_with_discount": "Total with discount",
    "label_discount_desc_error": "Discount must be between 0 and 100",
    "label_articles_report_not_permit": "You do not have access to the report",
    "label_not_permit_action": "You do not have permission to perform this action",
    "label_show_inventory": "Show inventory filter",
    "label_hide_inventory": "Hide inventory filter",
    "label_last_inventory": "In inventory",
    "label_last_inventory_label": "Last inventory",
    "label_last_inventory_update": "Update",
    "label_last_inventory_update_label": "Update inventory",
    "label_are_you_sure_to_update_inventory": "Are you sure you want to update the inventory for",
    "label_article_inventory_success": "Inventory successfully updated",
    "label_are_you_sure_to_update_inventory_not_in_stock": "ITEM IS NOT IN STOCK! When updating the inventory, it will be added to stock",
    "label_warehouse": "Warehouse",
    "label_warehouse_items_title": "Warehouse Items",
    "label_warehouse_item_add_title": "Add Warehouse Item",
    "label_warehouse_item_edit_title": "Edit Warehouse Item",
    "label_inventory_history": "Inventory History",
    "label_inventory_history_subtitle": "List of saved inventory counts",
    "label_inventory": "Inventory",
    "label_create_inventory": "Create inventory",
    "label_inventory_add_title": "New Inventory Count",
    "label_inventory_add_subtitle": "Enter counted quantity for each item",
    "label_current_stock_number": "Current stock",
    "label_inventory_quantity": "Counted quantity",
    "label_confirm_inventory": "Confirm inventory",
    "label_inventory_changed_items": "Changed items",
    "label_inventory_saved": "Inventory successfully saved",
    "label_inventory_no_changes": "No changed items for save",
    "label_inventory_invalid_quantity": "Quantity must be a whole number greater than or equal to 0",
    "label_note": "Note",
    "label_stock_number": "Quantity to Add",
    "label_company_info_id": "Company ID",
    "label_add": "Add",
    "label_no_data": "No Data",
    "label_success_delete": "Successfully Deleted",
    "label_all_field_required": "All required fields must be filled",
    "label_are_you_sure_delete": "Are you sure?",
    "label_are_you_sure_delete_desc": "Are you sure you want to delete the item",
    "label_purchase_price": "Purchase Price",
    "label_pay_with_credits": "Charge with Credits",
    "label_paid_with_credits": "Paid with Credits",
    "label_paid_with": "Paid with",
    "label_cash": "Cash",
    "label_card": "Card",
    "label_online_card": "Online card",
    "label_bar_pos_debt": "Unpaid",
    "label_pay_bill_description": "The bill will be marked as paid",
    "label_waiting_list_active": "Active",
    "label_waiting_list_active_one": "Active",
    "label_waiting_list_waiting": "Waiting",
    "label_waiting_list_expired": "Expired",
    "label_profit": "Profit",
    "label_period": "Period",
    "label_total_profit": "Total profit",
    "label_items_count": "Items",
    "label_show": "Show",
    "label_no_profit_data_for_period": "No data for the selected period",
    "label_profit_tab_orders": "Shop",
    "label_profit_tab_payments": "Memberships",
    "label_total_reservations": "Total reservations",
    "label_most_popular_term": "Most popular term",
    "label_most_popular_term_reservations": "Reservations of the most popular term",
    "label_most_popular_terms": "Most popular terms",
    "label_term_occupancy": "Term occupancy",
    "label_full_terms": "Full terms",
    "label_no_data_for_period": "No data for selected period",
    "label_no_weekly_report_data": "No data for weekly report",
    "label_weekly_report_title": "Weekly report",
    "label_entrance_total": "Total entrances",
    "label_entrance_most_popular_time": "Most popular time",
    "label_entrance_count_then": "Entrances at that time",
    "label_entrance_by_bucket": "Entrances by",
    "label_no_entrance_data_for_period": "No entrances for selected period",
    "label_hour": "hour",
    "label_time_bucket": "time bucket",
    "label_toggle_navigation_menu": "Toggle navigation menu",
    "label_close_navigation_menu": "Close navigation menu",
    "label_light_theme": "Light theme",
    "label_dark_theme": "Dark theme",
    "label_expand_sidebar": "Expand sidebar",
    "label_collapse_sidebar": "Collapse sidebar",
    "label_switch_to_topbar": "Move menu to top",
    "label_switch_to_sidebar": "Move menu to side",
    "label_reserving_training": "Reserving training...",
    "label_canceling_training": "Canceling training...",
    "label_no_trainer": "No trainer",
    "label_no_type": "No type",
    "label_waiting_list_title": "Waiting list",
    "label_user_report": "User report",
    "label_total_registrations": "Total registrations",
    "label_total_deleted_users": "Total deleted users",
    "label_expiring_this_month": "Expiring this month",
    "label_avg_renewal_rate": "Average renewal rate",
    "label_registrations_vs_deleted": "Registrations vs deleted",
    "label_registrations": "Registrations",
    "label_deleted_users": "Deleted users",
    "label_renewal": "Renewal",
    "label_expired_users": "Expired users",
    "label_not_renewed_users": "Not renewed users",
    "label_renewal_rate": "Renewal rate",
    "label_cohort_retention": "Cohort retention",
    "label_cohort_month": "Cohort month",
    "label_cohort_size": "Cohort size",
    "label_m1_active": "M1 active",
    "label_m2_active": "M2 active",
    "label_m3_active": "M3 active",
    "label_invalid_date_range": "Invalid date range",
};

let T_SR = {
    "day_monday": "Ponedeljak",
    "day_tuesday": "Utorak",
    "day_wednesday": "Sreda",
    "day_thursday": "Četvrtak",
    "day_friday": "Petak",
    "day_saturday": "Subota",
    "day_sunday": "Nedelja",
    "day_monday_short": "Pon",
    "day_tuesday_short": "Uto",
    "day_wednesday_short": "Sre",
    "day_thursday_short": "Čet",
    "day_friday_short": "Pet",
    "day_saturday_short": "Sub",
    "day_sunday_short": "Ned",
    "month_short_january": "Jan",
    "month_short_february": "Feb",
    "month_short_march": "Mar",
    "month_short_april": "Apr",
    "month_short_may": "Maj",
    "month_short_june": "Jun",
    "month_short_july": "Jul",
    "month_short_august": "Avg",
    "month_short_september": "Sep",
    "month_short_october": "Okt",
    "month_short_november": "Nov",
    "month_short_december": "Dec",
    "month_january": "Januar",
    "month_february": "Februar",
    "month_march": "Mart",
    "month_april": "April",
    "month_may": "Maj",
    "month_june": "Jun",
    "month_july": "Jul",
    "month_august": "Avgust",
    "month_september": "Septembar",
    "month_october": "Oktobar",
    "month_november": "Novembar",
    "month_december": "Decembar",
    "t_my_trainings": "Moji treninzi",
    "t_debtor": "Dugovanje",
    "t_free": "mesta",
    "t_free_single": "mesto",
    "t_see_all": "(vidi sve)",
    "t_active": "Aktivan",
    "t_deactive": "Neaktivan",
    "t_reserve": "ZAKAŽI",
    "t_cancel": "OTKAŽI",
    "t_waiting_list": "Lista\nčekanja",
    "t_waiting_list_cancel": "Otkaži\nčekanje",
    "label_home":"Početna",
    "label_trainings":"Treninzi",
    "label_trainings_report":"Izveštaj treninga",
    "label_users":"Korisnici",
    "label_bar_balance": "Šank balans",
    "label_balance_history": "Istorija salda",
    "label_balance_adjustment": "Ručna korekcija",
    "label_balance_add": "Dodaj",
    "label_balance_subtract": "Skini",
    "label_balance_updated": "Saldo uspešno ažuriran",
    "label_balance_amount_required": "Iznos je obavezan",
    "label_balance_amount_invalid": "Iznos može imati najviše 2 decimale",
    "label_balance_amount_zero": "Iznos ne može biti 0",
    "label_balance_note_required": "Napomena je obavezna",
    "label_balance_source_bill_create": "Račun na šanku",
    "label_balance_source_bill_cancel_return": "Povraćaj (storno računa)",
    "label_balance_source_bill_mark_paid": "Račun označen kao plaćen",
    "label_balance_source_mobile_app_credit_use": "Kupljen proizvod putem aplikacije",
    "label_balance_source_admin_adjustment": "Ručna korekcija admina",
    "label_balance_change_debit": "Skidanje",
    "label_balance_change_credit": "Dodavanje",
    "label_balance_users_report": "Izveštaj salda korisnika",
    "label_only_non_zero_balances": "Prikazani su samo korisnici sa saldom različitim od nule",
    "label_history": "Istorija",
    "label_actions": "Akcije",
    "label_add_subtract": "Dodaj/Skini",
    "label_type": "Tip",
    "label_source": "Izvor",
    "label_before": "Pre",
    "label_after": "Posle",
    "label_terms":"Predefinisani termini",
    "label_notifications":"Obaveštenja",
    "label_payments":"Uplate",
    "label_partners":"Saradnici",
    "label_companies":"Kompanije",
    "label_membership":"Članarina",
    "label_account":"Nalog",
    "label_logout":"Odjava",
    "label_login":"Prijava",
    "label_payment_expires_today":"Članarina vam ističe danas",
    "label_payment_already_expires":"Članarina vam je istekla",
    "label_please_extend_membership":"Molimo Vas da produžite članarinu.",
    "label_success": "Uspešno",
    "label_error": "Greška",
    "label_enter_company_code": "Molimo vas da unesete kod kompanije.",
    "label_company_code": "Kod kompanije",
    "label_company_code_loading": "Učitavanje...",
    "label_company_code_confirm": "Potvrdi",
    "label_choose_company_code": "Izaberi kompaniju",
    "label_company_not_exist": "Kompanija ne postoji.",
    "label_training_success_reserved": "Trening uspešno rezervisan.",
    "label_user_not_exist": "Korisnik ne postoji.",
    "label_please_wait": "Molimo sačekajte",
    "label_no_data_notifications": "Nema novih obaveštenja",
    "label_download_app": "Preuzmi aplikaciju klikom na ikonicu",
    "label_not_now": "Ne sada",
    "label_are_you_sure": "Da li ste sigurni?",
    "label_are_you_sure_delete_notification": "Da li ste sigurni da zelite da obrisete obaveštenje?",
    "label_yes": "Da",
    "label_no": "Ne",
    "label_primary": "Glavna",
    "label_set_as_primary": "Postavi kao glavnu",
    "label_add_photos": "Dodaj fotografije",
    "label_add_photos_hint": "Klikni za upload galerije artikla",
    "label_uploading": "Otpremanje...",
    "label_main_image_thumb": "Glavna",
    "label_cannot_set_primary": "Nije moguće postaviti glavnu sliku.",
    "label_kp_confirm_update": "Da li ste sigurni da želite da izmenite KP oglas?",
    "label_kp_confirm_park": "Da li ste sigurni da želite da parkirate KP oglas?",
    "label_kp_confirm_unpark": "Da li ste sigurni da želite da aktivirate KP oglas?",
    "label_kp_confirm_delete": "Da li ste sigurni da želite da obrišete KP oglas?",
    "label_kp_share_url_copied": "URL je kopiran.",
    "label_kp_share_url_missing": "Share URL je prazan.",
    "label_kp_gallery_panel": "KP + Galerija",
    "label_kp_section_title": "KupujemProdajem",
    "label_kp_ad_id": "KP ID oglasa",
    "label_kp_share_url": "Share URL",
    "label_kp_click_to_copy": "Klikni za kopiranje",
    "label_kp_copy": "Kopiraj",
    "label_kp_loading_categories": "Učitavanje kategorija...",
    "label_kp_loading_groups": "Učitavanje grupa...",
    "label_kp_category": "Kategorija",
    "label_kp_group": "Grupa",
    "label_kp_group_suggest_text": "Predlog naziva grupe",
    "label_kp_type": "Tip",
    "label_kp_condition": "Stanje",
    "label_kp_price": "Cena",
    "label_kp_currency": "Valuta",
    "label_kp_price_text": "Tekst cene",
    "label_kp_contact_placeholder": "Kontakt",
    "label_kp_post_date": "Datum kačenja",
    "label_kp_ad_age": "Starost oglasa",
    "label_kp_more_details": "Više detalja",
    "label_kp_less_details": "Manje detalja",
    "label_kp_immediate_available": "Odmah dostupno",
    "label_kp_exchange": "Zamena",
    "label_kp_price_fixed": "Fiksna cena",
    "label_kp_local_pickup": "Lično preuzimanje",
    "label_kp_courier_delivery": "Slanje kurirskom službom",
    "label_kp_description_html": "Opis (HTML)",
    "label_kp_editor_bold": "Podebljaj",
    "label_kp_editor_italic": "Iskosi",
    "label_kp_action_publish_loading": "Objava oglasa...",
    "label_kp_action_update_loading": "Izmena oglasa...",
    "label_kp_action_park_loading": "Parkiranje oglasa...",
    "label_kp_action_unpark_loading": "Aktiviranje oglasa...",
    "label_kp_action_unlink_loading": "Raskačivanje oglasa...",
    "label_kp_action_delete_loading": "Brisanje oglasa...",
    "label_kp_action_processing": "Obrada...",
    "label_kp_publish": "Okači na KP",
    "label_kp_update": "Izmeni oglas",
    "label_kp_park": "Parkiraj oglas",
    "label_kp_unpark": "Aktiviraj oglas",
    "label_kp_unlink": "Raskači sa KP",
    "label_kp_delete": "Obriši KP oglas",
    "label_upload_failed": "Otpremanje nije uspelo.",
    "label_are_you_sure_delete_image": "Da li ste sigurni da želite da obrišete sliku?",
    "label_delete_image_failed": "Brisanje slike nije uspelo.",
    "label_save_image_order": "Sačuvaj redosled slika",
    "label_image_order_saved": "Redosled slika je sačuvan.",
    "label_image_order_save_failed": "Neuspešno čuvanje redosleda slika.",
    "label_download_all_images_zip": "Preuzmi sve slike (ZIP)",
    "label_click_image_to_zoom": "Klikni na sliku za uvećanje",
    "label_kp_save_article_before_publish": "Sačuvaj artikal pre KP objave.",
    "label_kp_publish_success": "KP oglas je objavljen.",
    "label_kp_publish_error": "Greška pri objavi KP oglasa.",
    "label_kp_save_article_before_update": "Sačuvaj artikal pre KP izmene.",
    "label_kp_update_success": "KP oglas je izmenjen.",
    "label_kp_update_error": "Greška pri izmeni KP oglasa.",
    "label_kp_park_success": "KP oglas je parkiran.",
    "label_kp_park_error": "Greška pri parkiranju KP oglasa.",
    "label_kp_unpark_success": "KP oglas je aktiviran.",
    "label_kp_unpark_error": "Greška pri aktiviranju KP oglasa.",
    "label_kp_delete_success": "KP oglas je obrisan.",
    "label_kp_delete_error": "Greška pri brisanju KP oglasa.",
    "label_kp_confirm_unlink": "Ovo briše samo KP podatke iz naše baze. Oglas na KP ostaje aktivan. Da li nastavljate?",
    "label_kp_unlink_success": "KP podaci su lokalno obrisani.",
    "label_kp_unlink_error": "Greška pri raskačivanju KP podataka.",
    "label_kp_fill_after_create_question": "Da li želite da odmah popunite podatke za KP?",
    "label_kp_fill_now": "Popuni KP",
    "label_kp_post_new": "Okači novi oglas",
    "label_kp_import": "Povuci",
    "label_kp_import_id_only": "Uvezi ID samo",
    "label_kp_import_loading": "Povlačenje...",
    "label_kp_import_required": "KP ID je obavezan.",
    "label_kp_import_invalid": "KP ID mora biti pozitivan broj.",
    "label_kp_import_success": "KP oglas je uspešno povučen. Sinhronizovane slike",
    "label_kp_import_id_only_success": "KP ID je uspešno povezan. Podaci i slike nisu uvezeni.",
    "label_kp_import_error": "Greška pri povlačenju KP oglasa.",
    "label_kp_kind_goods": "Roba",
    "label_kp_kind_service": "Usluga",
    "label_kp_kind_job": "Posao",
    "label_kp_type_sell": "Prodaja",
    "label_kp_type_buy": "Kupovina",
    "label_kp_condition_new": "Novo",
    "label_kp_condition_as_new": "Nekorisceno",
    "label_kp_condition_used": "Korisceno",
    "label_kp_condition_damaged": "Osteceno",
    "label_cancel": "Otkaži",
    "label_success_delete_notification": "Uspešno obrisano obaveštenje",
    "label_add_term": "Dodaj termin",
    "label_see_terms": "Pregled termina",
    "label_search": "Pretraga",
    "label_amount_terms": "Ukupno termina",
    "label_amount_trainings": "Ukupno članova",
    "label_show_my_trainings": "Prikaži samo moje treninge",
    "label_name": "Ime",
    "label_surname": "Prezime",
    "label_date": "Datum",
    "label_time": "Vreme",
    "label_number_of_trainings": "Broj treninga",
    "label_number_of_not_arrived": "Broj nedolazaka",
    "label_equipment": "Oprema",
    "label_success_add_training": "Uspešno rezervisan trening.",
    "label_success_remove_training": "Uspešno otkazan trening.",
    "label_remove_training_title": "Otkazivanje treninga",
    "label_remove_training_title_are_you_sure": "Da li želite da otkazete trening?",
    "label_back_training": "Vraćanje treninga",
    "label_back_training_are_you_sure": "Da li želite da vratite trening korisniku?",
    "label_save": "Sačuvaj",
    "label_save_order": "Sačuvaj raspored",
    "label_drop_here": "Pusti ovde",
    "label_set_key": "Postavi ključ",
    "label_success_add_to_waiting_list": "Uspešno ste dodati na listu čekanja.",
    "label_success_remove_to_waiting_list": "Uspešno ste skinuti sa liste čekanja.",
    "label_remove_waiting_list": "Otkazivanje liste čekanja",
    "label_remove_waiting_list_are_you_sure": "Da li želite da otkazete listu cekanja?",
    "label_my_trainings": "Moji treninzi",
    "label_scheduled_trainings": "Zakazani treninzi",
    "label_no_scheduled_trainings": "Nema zakazanih treninga",
    "label_waiting_list": "Lista čekanja",
    "label_waiting_list_is_empty": "Lista čekanja je prazna",
    "label_see_all_trainings": "Prijave",
    "label_view_terms_for_day": "Pregled termina za",
    "label_day": "Dan",
    "label_training_type": "Tip",
    "label_training_type_title": "Tip treninga",
    "label_max_people": "Maximalno ljudi",
    "label_reserve_training": "Rezerviši trening",
    "label_edit": "Izmeni",
    "label_delete": "Obriši",
    "label_deactivate": "Deaktiviraj",
    "label_activate": "Aktiviraj",
    "label_reserve": "Reserviši",
    "label_are_you_sure_activate_term": "Da li ste sigurni da zelite da aktivirate termin",
    "label_are_you_sure_deactivate_term": "Da li ste sigurni da zelite da deaktivirate termin",
    "label_are_you_sure_delete_term": "Da li ste sigurni da zelite da obrišete termin",
    "label_term_activated": "Termin uspešno aktiviran",
    "label_term_deactivated": "Termin uspešno deaktiviran",
    "label_term_deleted": "Termin uspešno obrisan",
    "label_edit_term": "Izmeni termin",
    "label_term_success_updated": "Termin uspešno izmenjen.",
    "label_term_success_saved": "Termin uspešno dodat.",
    "label_send_notification": "Pošalji notifikaciju",
    "label_add_user_to_term": "Dodaj korisnika na trening",
    "label_user_will_be_added_to_term": "će biti dodat na ovaj termin ",
    "label_some_user_expire_payment": "Za nekog korisnika je istekla članarina, morate prvo da produžite članarinu.",
    "label_choose_user": "Izaberi korisnika",
    "label_search_users": "Pretraga korisnika...",
    "label_username": "Korisničko ime",
    "label_select": "Izaberi",
    "label_click_to_select_user": "Klikni da izabereš korisnika",
    "label_pagination_first": "prva",
    "label_pagination_previous": "prethodna",
    "label_pagination_next": "sledeća",
    "label_pagination_last": "poslednja",
    "label_pagination_amount": "Ukupno stavki",
    "label_from":"Od",
    "label_to":"Do",
    "label_do_search":"Pretraži",
    "label_show_weekly_report":"Prikaži nedeljni izvestaj",
    "label_amount":"Ukupno",
    "label_currency":"RSD",
    "label_number_of_terms":"Broj termina",
    "label_average":"Prosek",
    "label_rest_trainings":"Ostatak treninga",
    "label_partner":"Sradnik",
    "label_add_user":"Dodaj korisnika",
    "label_users_show_only_debtor":"Prikaži samo dužnike",
    "label_users_amount":"Ukupno korisnika",
    "label_serial_num":"R. br",
    "label_paid":"Uplaćeno",
    "label_paid_from": "Važi od",
    "label_expire":"Isticanje",
    "label_payment_type":"Tip uplate",
    "label_are_you_sure_to_delete_user":"Da li ste sigurni da zelite da obrisete korisnika",
    "label_user_deleted_success":"Korisnik uspešno obirsan",
    "label_are_you_sure_to_add_training_to_user":"Da li ste sigurni da zelite da dodate trening korisniku",
    "label_are_you_sure_to_remove_training_to_user":"Da li ste sigurni da zelite da uklonite trening korisniku",
    "label_training_removed_success":"Uspešno skinut trening",
    "label_training_add_success":"Uspešno dodat trening",
    "label_email":"Email",
    "label_phone":"Phone",
    "label_close":"Zatvori",
    "label_rest_of_trainings":"Preostalo treninga",
    "label_choose_trainings":"Izaberi treninge",
    "label_role":"Uloga",
    "label_role_user":"Korisnik",
    "label_role_trainer":"Trener",
    "label_role_admin":"Admin",
    "label_choose":"Izaberi",
    "label_current":"Trenutni",
    "label_delete_trainer":"Izbriši",
    "label_user_added":"Korisnik dodat",
    "label_user_edited":"Korisnik ažuriran",
    "label_update_user":"Ažuriraj korisnika",
    "label_reset_password":"Resetuj lozinku",
    "label_see_payments":"Pregled uplata",
    "label_are_you_sure_to_reset_password_to_user":"Da li ste sigurni da zelite da resetujete lozinku za korisnika?",
    "label_password_update":"Lozinka uspešno ażurirana",
    "label_picture":"Slika",
    "label_add_payment": "Dodaj uplatu",
    "label_payment_date": "Datum uplate",
    "label_payment_expire_date": "Datum isticanja",
    "label_payment_num_trainings": "Broj treninga",
    "label_payment_type_trainings": "Tip treninga",
    "label_payment_money": "Cena",
    "label_payment_link_invoice": "Link računa",
    "label_payment_for_company": "Uplata za kompaniju",
    "label_payment_equipment": "Oprema",
    "label_payment_error_choose_type": "Izaberite tip treninga",
    "label_payment_success_add": "Uspešno dodata uplata",
    "label_payment_success_edit": "Uspešno izmenjena uplata",
    "label_edit_payment": "Izmeni uplatu",
    "label_add_equipment": "Dodaj novu opremu",
    "label_training_type_add": "Dodaj novi tip",
    "label_payment_for": "Uplata za",
    "label_payment_loyalty": "Loyalty",
    "label_payment_add_new": "Dodaj uplatu",
    "label_payment_are_you_sure_to_delete": "Da li ste sigurni da zelite da obrisete uplatu?",
    "label_edit_account": "Izmeni naloga",
    "label_success_edit_profile": "Uspešno izmenjeni podaci.",
    "label_are_you_sure_to_delete_account": "Da li ste sigurni da zelite da obrisete nalog? Nalog mozete da povratite ponovnom prijavom.",
    "label_success_deleted": "Nalog uspešno obrisan",
    "label_success_extend_payment": "Uspešno produzena clanarina.",
    "label_active_payment": "Aktivna članarina",
    "label_history_payment": "Istorija uplata",
    "label_active_payment_expire": "Članarina važi do",
    "label_active_payment_price": "Uplata",
    "label_active_payment_tr_numbers": "Uplaćeno treninga",
    "label_active_payment_type": "Tip treninga",
    "label_active_payment_rest": "Ostalo",
    "label_extend_payment": "Produži članarinu",
    "label_history_payment_from": "Važi od",
    "label_history_payment_to": "do",
    "label_show_invoice": "Prikaži račun",
    "label_edit_profile": "Izmeni profil",
    "label_change_password": "Promeni lozinku",
    "label_delete_account": "Obriši nalog",
    "label_delete_account_success": "Nalog uspešno obrisan",
    "label_term_title": "Predefinisani termini",
    "label_open_term": "Otvori termine",
    "label_add_new_type_trainings": "Dodaj novi tip treninga",
    "label_delete_searched_terms": "Obriši pronadjene termine",
    "label_created_by": "Kreirao",
    "label_are_you_sure_delete_found_terms": "Da li ste sigurni da zelite da obrisete pronadjene termine?",
    "label_terms_deleted_success": "Termin uspešno obirsani termini",
    "label_term_deleted_success": "Termin uspešno obirsan",
    "label_add_notification": "Dodaj obaveštenje",
    "label_notification_priority": "Prioritet",
    "label_notification_low": "Nizak",
    "label_notification_medium": "Srednji",
    "label_notification_high": "Visok",
    "label_link": "Link",
    "label_choose_days": "Izaberi dane",
    "label_term_add_user_to_term": "Dodaj korisnika na termin",
    "label_term_user_will_be_added": "će biti dodat na ovaj termin",
    "label_term_choose_at_least_day": "Morate izabrati bar jedan dan.",
    "label_term_added_success": "Uspešno dodati termini",
    "label_term_edit_term": "Ažuriraj termin",
    "label_term_edit_term_success": "Uspešno izmenjen termin",
    "label_open_trainings_for": "Otvori treninge za",
    "label_open_trainings_for_desc": "Ukoliko ostavite datum prazan kreiraće se termini za",
    "label_open_trainings_success": "Trening uspešno otvoreni termini.",
    "label_count_payments": "Broj uplata",
    "label_add_partner": "Dodaj",
    "label_name_of_partner": "Ime partnera",
    "label_partner_add_title": "Dodaj partnera",
    "label_partner_edit_title": "Izmeni partnera",
    "label_partner_all_field_required": "Polje ne sme biti prazno",
    "label_old_password": "Stara lozinka",
    "label_new_password": "Nova lozinka",
    "label_repeat_password": "Ponovi lozinku",
    "label_password_error_not_empty": "Nova lozinka ne sme biti prazna",
    "label_password_error_old_password_not_empty": "Stara lozinka ne sme biti prazna",
    "label_password_error_repeat_same_password": "Ponovite istu lozinku",
    "label_password_success_changed": "Uspešno promenjena lozinka",
    "label_password": "Lozinka",
    "label_do_login": "Prijavi se",
    "label_no_data_trainings": "Za izabrani datum nema termina",
    "label_no_membership": "Nema aktivne članarine",
    "label_no_membership_history": "Nema prethodnih uplata",
    "label_input_serbian": "Unesite text na srpskom",
    "label_input_english": "Unesite text na engleskom (opciono)",
    "label_input_title_serbian": "Unesite naslov na srpskom",
    "label_input_title_english": "Unesite naslov na engleskom (opciono)",
    "label_load_image": "Učitaj sliku",
    "label_edit_picture": "Izmeni sliku",
    "label_max_size_picture": "Maximalna veličina fajla je 5 MB",
    "label_image_upload_error": "Greška prilikom upload-a slike.",
    "label_edit_notification": "Izmeni notifikaciju",
    "label_notification_empty": "Obaveštenje ne sme biti prazno!",
    "label_notification_title_empty": "Naslov obaveštenja ne sme biti prazno!",
    "label_notification_add_success": "Uspešno dodato obaveštenje",
    "label_notification_edit_success": "Uspešno izmenjeno obaveštenje",
    "label_open_terms_for_current_week": "Otvori ove termnie za tekucu nedelju",
    "label_training_history": "Istorija treninga",
    "label_training_history_is_empty": "Istorija treninga je prazna",
    "label_created_edited": "Kreirao/izmenio",
    "label_user_training_type": "Tip uplate",
    "label_training_key": "Klučić",
    "label_add_key": "Dodaj ključ",
    "label_max_people_on_training": 'Broj ljudi na treningu',
    "label_name_for_partner": 'trener',
    "label_mp_title": 'Paketi članarine',
    "label_mp_name": 'Ime paketa',
    "label_mp_add": 'Dodaj paket',
    "label_mp_during_in_days": 'Trajanje paketa u danima',
    "label_mp_price": 'Cena paketa',
    "label_membership_are_you_sure_to_delete": 'Da li ste sigurni da želite da obrišete paket?',
    "label_birthday": 'Rodjendan',
    "label_payment_paid_date": 'Datum plaćanja',
    "label_loyalty": 'Loyalty',
    "label_success_delete_payment": "Uspešno obrisana uplata",
    "label_buy_membership": "Kupi Članarinu",
    "label_buy_membership_from_date": "Izaberi datum početka članarine",
    "label_please_select_date": "Molimo Vas da izaberete Datum početka važenja članarine",
    "label_success_bought_membership": "Uspešno ste kupili članarinu.",
    "label_current_busy": "Trenutna gužva u teretani",
    "label_invoices": "Fakture",
    "label_invoices_created_successfully": "Uspešo kreirana faktura/fakture",
    "label_created": "Kreirano",
    "label_paid_yes": "Da",
    "label_paid_no": "Ne",
    "label_number_user_for_invoice": "Obračunatih korisnika",
    "label_set_paid": "Postavi plaćeno",
    "label_current_balance": "Trenutno stanje kredita",
    "label_invoice_are_you_sure_to_delete": "Da li ste sigurni da želite da obrišete fakturu?",
    "label_add_invoice": "Dodaj fakturu",
    "label_invoice_create_all_confirm": "Da li ste sigurni da želite da izdate fakture za sve kompanije?",
    "label_invoice_item_price": "Cena stavke",
    "label_invoice_item_count": "Količina",
    "label_invoice_type": "Tip fakture",
    "label_invoice_all_field_required": "Sva polja su obavezna",
    "label_add_invoice_all": "Izdaj fakture za sve",
    "label_invoice_report": "Izveštaj faktura",
    "label_monthly_turnover": "Mesečni promet",
    "label_turnover_by_company": "Promet po kompaniji",
    "label_total_turnover": "Ukupan promet",
    "label_debtors": "Dužnici",
    "label_debtors_list": "Lista dužnika",
    "label_no_minus_invoices_for_period": "Nema minus faktura za izabrani period",
    "label_no_permission_for_report": "Nemate dozvolu za ovaj izveštaj",
    "label_download_pdf": "Skini PDF",
    "label_pdf": "PDF",
    "label_category_membership": "Kategorija (opciono)",
    "label_add_category_membership": "Dodaj novu kategoriju",
    "label_insert_name_category_membership": "Unesite ime kategorije",
    "label_mp_category": "Kategorija",
    "label_ci_training_add": "Dodaj novi trening",
    "label_ci_training_name": "Ime treninga",
    "label_ci_training_name_en": "Ime treninga (en)",
    "label_ci_training_short_desc": "Kratak opis",
    "label_ci_training_short_desc_en": "Kratak opis (en)",
    "label_ci_training_long_desc": "Duži opis",
    "label_ci_training_long_desc_en": "Duži opis (en)",
    "label_ci_training_image": "Slika",
    "label_ci_training_choose_image": "Izaberi sliku",
    "label_ci_training_kcal": "Potrošnja kalorija",
    "label_ci_training_minutes": "Trajanje treninga u minutama",
    "label_ci_training_intensity": "Itezitet treninga (0 - 5)",
    "label_ci_training_required": "Obavezno: ime, kratak opis, duži opis, slika",
    "label_ci_training_success_add": "Uspešno dodat trening",
    "label_ci_training_are_you_sure": "Da li ste sigurni da želite da obrišete: ",
    "label_trainers": "Treneri",
    "label_ci_trainer_add": "Dodaj novog trenera",
    "label_user_added_success_add_payment": "Korisnik je uspešno dodat! Da li želite da mu dodate prvu uplatu?",
    "label_set_trainings_number": "Postavi broj treninga",
    "label_ci_nutrition_add": "Dodaj novu stavku",
    "label_ci_nutrition": "Blog",
    "label_ci_nutrition_name": "Ime stavke",
    "label_ci_nutrition_name_en": "Ime stavke (en)",
    "label_ci_nutrition_short": "Kratak opis",
    "label_ci_nutrition_short_en": "Kratak opis (en)",
    "label_ci_nutrition_long": "Duži opis",
    "label_ci_nutrition_long_en": "Duži opis (en)",
    "label_articles": "Arktili",
    "label_on_waiting": "Na čekanju",
    "label_amount_articles": "Ukupno artikala",
    "label_a_name": "Ime",
    "label_a_category": "Kategorija",
    "label_a_sub_category": "Podkategorija",
    "label_a_memory": "Memorija",
    "label_a_purchase_price": "Nabavna cena",
    "label_a_selling_price": "Prodajna cena",
    "label_a_desc": "Opis",
    "label_a_comment": "Komentar",
    "label_add_article": "Dodaj artikl",
    "label_a_stock": "Količina",
    "label_a_statuses": "Status",
    "label_a_statuses_show": "Pregled radnji",
    "label_article_added": "Uspešno dodat artikl",
    "label_article_updated": "Uspešno ažuriran artikl",
    "label_a_stock_number": "Količina",
    "label_a_stock_number_set": "Postavi količinu",
    "label_update_article": "Ažuriraj artikl",
    "label_are_you_sure_to_remove_article": "Da li ste sigurni da želite da obrišete artikl?",
    "label_are_you_sure_to_remove_category": "Da li ste sigurni da želite da obrišete kategoriju?",
    "label_article_removed_success": "Artikl obrisan",
    "label_a_code": "Kod",
    "label_a_c_add": "Dodaj kategorije",
    "label_a_c_add_sub_for": "Dodaj podkategoriju za ",
    "label_a_c": "Kategorije",
    "label_a_c_sub": "Podkategorija",
    "label_a_c_see_sub": "Pregled podkategorija",
    "label_back_to_all_categories": "Povratak na sve kategorije",
    "label_show_filters": "Prikaži filtere",
    "label_clear_filters": "Očisti filtere",
    "label_a_c_edit_sub_for": "Izmeni podkategoriju za ",
    "label_a_c_name": "Dodaj kategoriju ",
    "label_choose_imei": "Izaberi imei",
    "label_crop_image": "Iseci kod",
    "label_article_approve": "Potvrdi",
    "label_article_approved_success": "Uspoešna potvrda",
    "label_are_you_sure_to_approve_article": "Da li želite da potvrdite ",
    "label_article_all": "Svi",
    "label_article_for_approve": "Za potvrdu",
    "label_article_active": "Aktivni",
    "label_article_service": "Na servisu",
    "label_article_sold": "Prodati",
    "label_article_waiting_approve": "Na čekanju",
    "label_imei_error": "Imei mora imati tačno 15 brojeva",
    "label_serial_number_error": "Serijski broj ne sme biti prazan",
    "label_are_you_sure_to_add_to_stock": "Da li ste sigurni da dodajete na stanje ",
    "label_are_you_sure_to_remove_to_stock": "Da li ste sigurni da skidate na stanja ",
    "label_article_add_to_stock": "Dodaj na stanje",
    "label_article_remove_to_stock": "Prodat",
    "label_buy_date": "Datum kupovine",
    "label_article_already_exist": "Artikl već postoji",
    "label_article_are_you_sure_update_already": "Da li želite da ažurirate postojeci artikl?",
    "label_ci_shop": "Prodavnica",
    "label_ci_shop_add": "Dodaj proizvod",
    "label_ci_shop_name": "Ime proizvoda",
    "label_ci_shop_name_en": "Ime proizvoda (en)",
    "label_ci_shop_short_desc": "Kratak opis",
    "label_ci_shop_short_desc_en": "Kratak opis (en)",
    "label_ci_shop_long_desc": "Duži opis",
    "label_ci_shop_long_desc_en": "Duži opis (en)",
    "label_ci_shop_success_add": "Proizvod uspešno dodat.",
    "label_ci_shop_price": "Cena",
    "label_ci_shop_currency": "Valuta",
    "label_ci_mobile_settings": "Aplikacija",
    "label_ci_header_image": "Naslovna slika na početnoj stranici aplikacije",
    "label_ci_header_image_uploaded_success": "Naslovna slika postavljena.",
    "label_ci_header_photo_delete_are_you_sure": "Da li ste sigurni da želite da sklonite naslovnu sliku sa aplikacije?",
    "label_ci_header_image_deleted_success": "Naslovna slika obrisana.",
    "label_ci_header_image_info_desc_1": "Naslovna slika za aplikaciju",
    "label_ci_header_image_info_desc_2": "Ova slika ce biti prikazana korisnicima na početnoj strani",
    "label_a_color": "Boja",
    "label_internal_code": "Interni kod",
    "label_search_internal_code": "Pretraga po internom kodu",
    "label_see_colors": "Pregled boja",
    "label_category_name": "Ime",
    "label_add_new_color": "Dodaj novu boju",
    "label_show_personal_message": "Dodaj personalizovane poruke",
    "label_show_personal_message_desc": "Ukoliko oznacite neki tip, samo korisnici koji imaju označen tip prilikom uplate će da vide ovo obaveštenje",
    "label_show_sort": "Sortiranje",
    "label_clear_sort": "Sakri sortiranje",
    "label_sort_by_date": "Sortiraj po datumu",
    "label_sort_by_abs": "Sortiraj po abecedi",
    "label_ci_trainer_name": "Ime trenera",
    "label_ci_trainer_name_en": "Ime trenera (en)",
    "label_a_ram_memory": "Ram memorija",
    "label_article_sent_by_post": "Poslat poštom",
    "label_show_more": "Prikaži više",
    "label_show_less": "Prikaži manje",
    "label_not_active_more": "Neaktivne duže od",
    "label_not_active_more_3": "3 meseca",
    "label_not_active_more_6": "6 meseci",
    "label_price": "Cena",
    "label_success_update_waiting_list": "Uspešno ažurirana lista čekanja",
    "label_show_users_more": "Prikaži",
    "label_expire_payment_users": "Prikaži korisnike kome je istekla članarina",
    "label_active_users": "Aktivne korisnike",
    "label_active_users_last_30_days": "Aktivne korisnike prethodnih 30 dana",
    "label_not_active_users": "Neaktivne korinike",
    "label_article_archived": "Arhivirani",
    "label_are_you_sure_to_recovery_article": "Da li ste sigurni da želite da povratite artikl",
    "label_article_recovered_success": "Uspešno povraćen artikl",
    "label_recovery": "Povrati",
    "label_ci_shop_discount": "Popust",
    "label_ci_position": "Pozicija u listi",
    "label_ci_position_desc": "Ukoliko ostavite 0 u ovom polju, stavka ce biti dodata kao poslednja u listi",
    "label_standard_payment": "Standardna uplata",
    "label_additional_payment": "Dodatne usluge",
    "label_payment_types": "Tip uplate",
    "label_activate_all": "Aktiviraj sve",
    "label_activate_all_desc": "Da li želite da aktivirate sve termine?",
    "label_deactivate_all": "Deaktiviraj sve",
    "label_deactivate_all_desc": "Da li želite da deaktivirate sve termine?",
    "label_format_of_time_not_valid": "Format vremena mora da bude sledeci: HH:mm (primer 12:20)",
    "label_term_choose_at_least_time": "Morate dodati bar jedno vreme. Vreme dodajete tako što prvo unesete vreme koje želite i onda kliknete na + sa desne strane.",
    "label_important": "Važno",
    "label_qr_code_training_type": "QR kod ulazak",
    "label_approved": "Potvrda",
    "label_approve": "Potvrdi",
    "label_approve_are_you_sure": "Da li ste sigurni da želite da potvrdite trening za:",
    "label_success_approved_training": "Uspešno potvrdjen trening",
    "total_debt": "Ukupan dug",
    "label_activate_all_filtered": "Aktiviraj pronadjene",
    "label_deactivate_all_filtered": "Deaktiviraj pronadjene",
    "label_deactivate_all_desc_filtered": "Da li želite da deaktivirate pronadjene termine?",
    "label_activate_all_desc_filtered": "Da li želite da aktivirate pronadjene termine?",
    "label_delete_and_cancel_all_users": "Obriši i otkaži sve treninge",
    "label_success_added_user": "Uspešno dodat korisnik",
    "label_success_qr_code_scan": "Uspešna prijava preko QR koda",
    "label_success_qr_code_scan_title": "Uspešna prijava",
    "label_success_qr_code_approve": "Uspešna prijava preko QR koda",
    "label_success_qr_code_approve_title": "Uspešna potvrda",
    "label_user": "Korisnik",
    "label_expire_payment_for_user": "Članarina istekla",
    "label_shop_link": "Link do prodavnice",
    "label_entrance": "QR Ulaz",
    "label_entrance_success_reserved": "Uspešno skeniran kod",
    "label_a_code_serial": "Serijski broj",
    "label_desc_training_filter_on_report": "*Napomena: izabrani termin iz liste se odnosi samo na odabrani početni datum",
    "label_choose_location": "Izaberite lokaciju: ",
    "label_choose_location_desc": "*Napomena: ukoliko ne izaberete ni jednu lokaciju, stavka će se videti na svim lokacijama",
    "label_quantity_for_buy": "Količina za kupovinu",
    "label_quantity_for_buy_desc": "*broj komada koji ce korisnik da kupi, npr.: prodajete 3 čokoladice po sniženoj ceni, onda ovde upišete 3",
    "label_buy": "Kupi",
    "label_order": "Poruči",
    "label_are_you_sure_buy_item": "Da li ste sigurni da želite da kupite proizvod: ",
    "label_successfully_bought_item": "Uspešno kupljen proizvod. Možete pogledati stanje proizvoda u svom novačniku.",
    "label_are_you_sure_order_item": "Da li ste sigurni da želite da preuzmete proizvod: ",
    "label_successfully_ordered_item": "Uspešno poručen proizvod. Možete pogledati stanje proizvoda u svom novačniku.",
    "label_tab_orders": "Porudžbine",
    "label_orders_bought": "Kupljeni proizvodi",
    "label_orders_used": "Iskorišteni proizvodi",
    "label_are_you_sure_cancel_order": "Da li ste sigurni da želite da otkažete porudžbinu: ",
    "label_order_canceled_successfully": "Da li ste sigurni da želite da otkažete porudžbinu: ",
    "label_user_wallet_quantity": "Količina za trošenje",
    "label_user_wallet_used": "Iskorišteno",
    "label_shop_qr": "QR kod",
    "label_shop_qr_list": "QR lista",
    "label_enter_fullscreen": "Uđi u fullscreen",
    "label_exit_fullscreen": "Izađi iz fullscreen-a",
    "label_fullscreen_failed": "Nije moguće promeniti fullscreen režim.",
    "label_are_you_sure_pay_user_wallet": "Da li ste sigurni da želite da potvrdite plaćanje: ",
    "label_user_wallet_paid_successfully": "Plaćenje uspešno postavljeno",
    "label_action": "Akcija",
    "label_action_for_item": "Akcija za proizvod",
    "label_ci_shop_edit": "Izmeni proizvod",
    "label_personal": "Personalni program",
    "label_wod": "WOD",
    "label_wod_program_display_error": "Neuspešno prikazivanje programa. Pokušajte kasnije.",
    "label_add_td": "Dodaj novi trening",
    "label_td_name": "Ime treninga",
    "label_td_name_en": "Ime treninga (en)",
    "label_td_short_desc": "Kraći opis",
    "label_td_short_desc_en": "Kraći opis (en)",
    "label_td_long_desc": "Duži opis",
    "label_td_long_desc_en": "Duži opis (en)",
    "label_delete_training_of_the_day_successfully": "Uspešno obrisan trening",
    "label_delete_training_of_the_day": "Brisanje treninga",
    "label_delete_training_of_the_day_are_you_sure": "Da li ste sigurni da želite da obrišete trening",
    "label_success_added_training_of_the_day": "Uspešno dodat trening",
    "label_choose_exist_training": "Izaberi postojeći trening",
    "label_search_trainings_definition": "Pretraži treninge",
    "label_edit_td": "Izmeni trening",
    "label_success_edited_training_of_the_day": "Uspešno izmenjen trening",
    "label_td_name_required": "Ime je obavezno",
    "label_all_wod_trainings": "Pregled svih treninga",
    "label_all_personal_trainings": "Pregled svih vežbi",
    "label_all_wod_trainings_title": "Pregled svih WOD treninga",
    "label_search_personal_trainings_definition": "Pretraži vežbe",
    "label_add_new_pt_exercise": "Dodaj novu vežbu",
    "label_td_pt_name": "Ime vežbe",
    "label_td_pt_video": "Link do video snimka",
    "label_td_pt_name_en": "Ime vežbe (en)",
    "label_td_pt_short_desc": "Kraći opis",
    "label_td_pt_short_desc_en": "Kraći opis (en)",
    "label_td_pt_long_desc": "Duži opis",
    "label_td_pt_long_desc_en": "Duži opis (en)",
    "label_video": "Video",
    "label_add_new_personal_program": "Dodaj novi program",
    "label_personal_title": "Personalni program",
    "label_pp_active": "Aktivni programi",
    "label_pp_not_active": "Neaktivni programi",
    "label_pp_predefined_programs": "Predefinisani programi",
    "label_pp_name": "Ime programa",
    "label_pp_name_en": "Ime programa (en)",
    "label_pp_from_date": "Trajanje programa od",
    "label_pp_from_to": "Trajanje programa do",
    "label_pp_choose_user": "Izaberite korisnika za program",
    "label_pp_choose_user_or_partner": "Izaberite korisnika ili eksternog partnera",
    "label_pp_success_saved": "Uspešno sačuvan program",
    "label_pp_user_to_be_added": "će biti dodat na program",
    "label_pp_add_user_to_program": "Izaberi korisnika na program",
    "label_delete_personal_program": "Brisanje programa",
    "label_delete_personal_program_are_you_sure": "Da li ste sigurni da želite da obrišete program",
    "label_delete_personal_program_successfully": "Uspešno obrisan program",
    "label_edit_exercise": "Uredi vežbe",
    "label_edit_personal_program": "Izmeni program",
    "label_pp_title": "Personalni program",
    "label_all_the_exercises": "Pregledaj sve vežbe",
    "label_not_include_in_program": "Nije uključeno",
    "label_my_active_program": "Aktuelni programi",
    "label_amount_purchase_price": "Ukupna nabavna cena",
    "label_wod_type_training": "Tip",
    "label_wod_category_training": "Kategorija",
    "label_wod_coach_notes": "Napomena za trenera",
    "label_td_type": "Tip",
    "label_td_category": "Kategorija",
    "label_td_add_category": "Dodaj kategoriju",
    "label_td_add_category_insert_name": "Unesi ime nove kategorije",
    "label_td_add_category_save_name": "Sačuvaj novu kategoriju",
    "label_td_category_choose": "Izaberi kategoriju",
    "label_td_category_choosed_delete": "Obriši izabranu kategoriju",
    "label_company_partners": "Eksterni saradnici",
    "label_number_of_people_for_company": "Maksimalni ljudi koji koriste",
    "label_are_you_sure_delete_partner": "Da li ste sigurni?",
    "label_are_you_sure_delete_partner_desc": "Da li ste sigurni da želite da obrišete",
    "label_partner_success_delete": "Uspešno brisanje.",
    "label_copy_program": "Kopiraj program",
    "label_copy_program_action": "Kopiraj",
    "label_assign_program_action": "Dodeli",
    "label_without_company_partners": "Bez eksternog partnera",
    "label_personal_user": "Korisnik",
    "label_personal_company": "Kompanija",
    'label_download_qr_code': 'Skini kao sliku',
    'label_pt_other_category': 'Ostalo',
    'label_user_type_online': 'Online korisnik',
    'label_user_type_training_center': 'Trening centar',
    'label_user_type_both': 'Online i trening centar',
    'label_user_type': 'Tip korisnika',
    'label_no_workouts': 'Trenutno nema postavljenih vežbi',
    'label_no_active_programs': 'Trenutno nema aktivnog programa',
    'label_view': 'Pregled programa',
    'label_download_report': 'Skini izveštaj',
    'label_user_credit': 'CashBack krediti',
    'label_add_credits': 'Dodaj kredite',
    'label_take_credits': 'Skini kredite',
    'label_mp_action': 'Da li paket na akciji?',
    'label_choose_company': 'Izaberite vašu kompaniju',
    'label_documentations': 'Dokumentacija',
    'label_td_results_config': 'Podešavanje rezultata',
    'label_td_add_measure_insert_name': 'Unesite ime mere',
    'label_td_add_result_measure': 'Dodaj novu meru',
    'label_td_measure_choose': 'Izaberi meru',
    'label_td_result_rounds': 'Broj serija',
    'label_td_measure_choosed_delete': 'Obriši izabranu meru',
    'label_result_repeat': 'Br. ponavljanja',
    'label_result_set': 'Serija',
    'label_completed': 'Završeno',
    'label_change_my_result': 'Upiši',
    'label_see_all_results': 'Svi rezultati',
    'label_wod_results': 'Rezultati',
    'label_see_wod_as_user': 'Pregled wod-a kao korisnik',
    'label_training_type_are_you_sure_to_delete': 'Da li želite da obrišete ',
    'label_success_update_training_types': 'Uspešno ažurirana lista',
    'label_training_types': 'Vrste treninga',
    'label_trainer_name': 'Trener',
    'label_credit_active': 'Aktivni',
    'label_credit_history': 'Istekli',
    'label_credit_used': 'Iskorišteni',
    'label_are_you_sure_delete_user_credit': 'Da li ste sigurni?',
    'label_are_you_sure_delete_user_credit_desc': 'Da li ste sigurni da želite da obrisete kredit?',
    'label_is_this_credit_type': 'Da li je ovo kredit? (ukoliko korisnik kupi ovo dodace mu se na stanje kredita)',
    'label_shoes_size': 'Broj cipela',
    'label_us_type': 'Tip kredita',
    'label_us_amount': 'Vrednost kredita',
    'label_us_amount_used': 'Iskorišćenost kredita',
    'label_us_created_date': 'Datum kreiranja',
    'label_us_valid_to': 'Važi do',
    'label_lesson_url': 'Link do lekcije',
    'label_user_additional_info': 'Dodatne informacije o korisniku',
    'label_home_trainings': 'Programi',
    'label_wod_total_result': 'Opcije za ukupan rezultat',
    'label_td_total_result_choose': 'Izaberi vrednost',
    'label_wod_total_result_min': 'Minimalni',
    'label_wod_total_result_max': 'Maksimalni',
    'label_wod_total_result_average': 'Prosek',
    'label_wod_total_result_sum': 'Suma',
    'label_wod_result_sort': 'Način sortiranja rezultata',
    'label_wod_result_sort_asc': 'Rastuce (najmanji je najbolji)',
    'label_wod_result_sort_desc': 'Opadajuce (najvecći je najbolji)',
    'label_total_result': 'Konačan rezultat',
    'label_hide_details': 'Prikaži manje',
    'label_show_details': 'Prikaži više',
    'label_gender': 'Pol',
    'label_gender_male': 'Muško',
    'label_gender_female': 'Žensko',
    'label_choose_gender': 'Izaberite pol za pretragu',
    'label_gender_man': 'Muškarci',
    'label_gender_woman': 'Žene',
    'label_copy_rd': 'Kopiraj dan',
    'label_copy_training_desc': 'Izaberite datume za koje želite da kopirate trening',
    'label_selected_dates': 'Odabrano datuma',
    'label_success_copy_trainings': 'Uspešno kopirani treninzi',
    'label_ci_events': 'Dogadjaji',
    'label_ci_event_add': 'Dodaj dogadjaj',
    'label_ci_item_name': 'Ime',
    'label_ci_item_name_en': 'Ime (en)',
    'label_ci_item_short_desc': 'Kraći opis',
    'label_ci_item_short_desc_en': 'Kraći opis (en)',
    'label_ci_item_long_desc': 'Duži opis (en)',
    'label_ci_item_long_desc_en': 'Duži opis (en)',
    'label_ci_item_success_add': 'Stavka uspešno dodata',
    'label_ci_event_sign_up': 'Prijavi se',
    'label_ci_event_sign_up_edit': 'Izmeni prijavu',
    'label_ci_event_fields': 'Potrebni podaci',
    'label_ci_event_fields_add_new': 'Unesi novi podatak',
    'label_ci_event_fields_add': 'Dodaj',
    'label_ci_event_all_users': 'Sve prijave',
    'label_event_info': 'Dodatne informacije',
    'label_ci_max_signups': 'Maksimalno prijava',
    'label_ci_event_successfully_sign_up': 'Uspešna prijava',
    'label_payment_comment': 'Dodatne napomene',
    'label_filter_day': 'dan',
    'label_filter_week': 'nedelja',
    'label_filter_month': 'mesec',
    'label_filter_show': 'Prikaz',
    'label_user_note_add': 'Unesi u dnevnik',
    'label_user_note_edit': 'Izmeni belešku',
    'label_user_note_delete_desc': 'Da li ste sigurni da želite da obrišete belešku?',
    'label_schedule': 'Smene',
    'label_budget': 'Budžet',
    'label_schedule_start': 'Počni smenu',
    'label_schedule_insert_money': 'Zaduži novac',
    'label_schedule_inserted_money': 'Zaduženo',
    'label_schedule_are_you_sure_to_delete': 'Da li ste sigurni da želite da obrišete smenu?',
    'label_success_delete_schedule': 'Uspešno obrisana smena',
    'label_schedule_out_money': 'Predato novca',
    'label_status': 'Status',
    'label_schedule_active': 'Otvorena',
    'label_schedule_finished': 'Zatvorena',
    'label_schedule_lock': 'Potvrdjeno zatvaranje',
    'label_approve_schedule_title': 'Potvrdi smenu',
    'label_approve_schedule': 'Potvrdi',
    'label_close_schedule_title': 'Zatvori smenu',
    'label_close_schedule': 'Zatvori',
    'label_schedule_inserted_money_current': 'Trenutno',
    'label_schedule_item_cost': 'Trošak/dobit',
    'label_plus': 'Plus',
    'label_minus': 'Minus',
    'label_amount_in': 'Iznos u',
    'label_article_for_change': 'Redni broj artikla za zamenu (6 cifara)',
    'label_insert_profit': 'Unesite zaradu',
    'label_comment': 'Komentar',
    'label_additional_cost_in': 'Dodatni trošak u',
    'label_download_training_data': 'Skini izveveštaj',
    'label_training_report_title': 'Izveštaj treninga',
    'label_additional_costs': 'Dodatni troškovi',
    'label_schedule_are_you_sure_to_approve': 'Da li ste sigurni da želite da potvrdite smenu?',
    'label_success_approved_schedule': 'Uspešno potvrdjena smena',
    'label_edit_schedule_title': 'Izmeni smenu',
    'label_add_amount': 'Dodaj iznos',
    'label_remove_amount': 'Vrati iznos',
    'label_article_for_change_title': 'Artikl za zamenu (opciono)',
    "label_send_message": "Sadržaj poruke",
    "label_title_message": "Naslov kampanje",
    "label_enter_email_title": "Unesite naslov poruke",
    "label_enter_email_text": "Unesite tekst poruke",
    "label_send_by_email": "Pošalji putem e-maila",
    "label_send_by_notification": "Pošalji kao notifikaciju",
    "label_send": "Pošalji",
    "label_chat": "Podrška",
    "label_admin_chat": "Podrška",
    "label_user_chat": "Podrška",
    "label_conversations": "Konverzacije",
    "label_no_conversations": "Nema konverzacija",
    "label_messages": "Poruke",
    "label_no_messages": "Nema poruka",
    "label_write_message": "Napišite poruku",
    "label_new_message_admin": "Poruka administratoru",
    "label_new_message_trainer": "Poruka treneru",
    "label_start_chat": "Započni chat",
    "label_start_conversation": "Počni konverzaciju",
    "label_chat_active": "Aktivne",
    "label_chat_closed": "Zatvorene",
    "label_close_conversation": "Zatvori konverzaciju",
    "label_close_conversation_confirm": "Da li želite da zatvorite ovu konverzaciju?",
    "label_chat_load_error": "Neuspešno učitavanje chat-a. Pokušajte ponovo kasnije.",
    "label_faq": "Najčešća pitanja",
    "label_faq_add_new": "Dodaj pitanje",
    "label_faq_question": "Pitanje",
    "label_faq_answer": "Odgovor",
    "label_faq_order_number": "Redosled",
    "label_faq_active": "Aktivno",
    "label_faq_inactive": "Neaktivno",
    "label_faq_empty": "Nema pitanja",
    "label_faq_edit": "Izmeni pitanje",
    "label_faq_delete_confirm": "Da li želite da obrišete ovo pitanje?",
    "label_conversation_not_available": "Konverzacija nije dostupna.",
    "label_admin": "Admin",
    "label_back": "Nazad",
    "label_selected_users": "Odabrani korisnici",
    "label_selected_companies": "Odabrane kompanije",
    "label_select_all": "Označi sve",
    "label_unselect_all": "Poništi izbor svih",
    "label_hide_filters": "Sakrij filtere",
    "label_reset_filters": "Resetuj filtere",
    "label_enter_email_title_en": "Unesite naslov na engleskom (opciono)",
    "label_enter_email_text_en": "Unesite tekst na engleskom (opciono)",
    "label_campaign_image_url": "URL slike (opciono)",
    "label_campaign_error_no_users_selected": "Odaberite bar jednog korisnika",
    "label_campaign_error_no_companies_selected": "Odaberite bar jednu kompaniju",
    "label_campaign_error_title_required": "Naslov kampanje je obavezan",
    "label_campaign_error_message_required": "Tekst kampanje je obavezan",
    "label_campaign": "Kampanja",
    "label_campaign_company": "Kampanja za kompanije",
    "label_add_campaign": "Napravi kampanju",
    "label_add_company_campaign": "Napravi kampanju za kompanije",
    "label_users_number": "Broj korisnika",
    "label_article_in_schedule": "Uračunaj u smenu",
    "label_open_door": "Otvori vrata",
    "label_trainer_report": "Izvestaj zaposlenih",
    "label_report_type": "Tip",
    "label_report": "Izveštaj",
    "label_report_total_slots": "Ukupno termina",
    "label_number_slots": "Broj termina",
    "label_tab_orders_reservation": "Rezervisani proizvodi",
    "label_location": "Lokacija",
    "label_time_pickup": "Vreme preuzimanja",
    "label_state_in_warehouse": "Stanje u lageru",
    "label_please_select_trainer": "Molimo vas izaberite trenera",
    "label_show_only_free_slots": "Prikaži samo slobodne termine",
    "label_do_search_by_slot": "Izveštaj po terminu",
    "label_do_search_by_user": "Izveštaj po korisniku",
    "label_reports": "Izveštaji",
    "label_include_in_schedule": "Uključi u smenu",
    "label_additional_cost": "Trošak",
    "label_schedule_profit": "Zarada",
    "label_change_profit": "Promeni zaradu",
    "label_articles_report": "Izveštaj",
    "label_report_summary": "Sažetak izveštaja",
    "label_by_currency": "Po valuti",
    "label_total_articles": "Ukupno artikala",
    "label_margin": "Marža",
    "label_total": "Ukupno",
    "label_article_log_report": "Izveštaj aktivnosti artikala",
    "label_article_log_report_hint": "Koristi iste Od/Do datume iz sekcije iznad.",
    "label_post_on_kp_count": "Postavljeno na KP",
    "label_selling_count": "Prodato",
    "label_uploaded_images_for_kp": "Dodato slika za KP",
    "label_article_log_dates_required": "Za ovaj izveštaj su obavezni Od i Do datumi.",
    "label_article_log_invalid_period": "Datum Od mora biti manji ili jednak datumu Do.",
    "label_c_schedule_user_report": "Izveštaj profita po korisniku",
    "label_c_schedule_user_report_hint": "Koristi iste Od/Do datume iz sekcije iznad.",
    "label_turnover_eur": "Promet EUR",
    "label_turnover_rsd": "Promet RSD",
    "label_profit_eur": "Zarada EUR",
    "label_are_you_sure_to_show_all": "Zelite li da prikažete sve",
    "label_end_date": "Datum završetka",
    "label_ci_event_edit": "Izmeni dogadjaj",
    "label_ci_event_location": "Lokacija",
    "label_ci_event_price": "Cena",
    "label_choose_package": "Izaberi paket",
    "label_view_table": "Tabelarni prikaz",
    "label_view_slot": "Prikaži sve slotove",
    "label_expire_to_days": "istice za ... dana",
    "label_download_user_report": "Prikazi izvestaj",
    "label_trainer": "Trener",
    "label_mp_for_program": "Da li je clanarina za program?",
    "label_program_buy": "Kupi program",
    "label_start_program": "Počni program",
    "label_program_filter_all": "Svi programi",
    "label_program_filter_bought": "Kupljeni",
    "label_program_filter_free": "Besplatni",
    "label_program_filter_lock": "Zaključani",
    "label_program_is_free": "Da li je program besplatan?",
    "label_program_is_template": "Da li želite da bude predefinisan program?",
    "label_regular_sell": "Prodaja",
    "label_regular_supply": "Redovna nabavka",
    "label_pp_short_desc": "Kraći opis",
    "label_pp_short_desc_en": "Kraći opis (en)",
    "label_pp_long_desc": "Duži opis",
    "label_pp_long_desc_en": "Duži opis (en)",
    "label_total_price": "Ukupna cena",
    "label_returned_amount": "Kusur",
    "label_schedule_item": "Izmeni stavku smene",
    "label_type_active": "Otvorene",
    "label_type_closed": "Zatvorene",
    "label_type_approved": "Potvrdjene",
    'label_article_for_change_button': 'Artikl za zamenu',
    'label_color_delete_are_you_sure': 'Boja će biti obrisna iz istorije',
    'delete_color_from_history': 'Obriši boju iz istorije',
    'label_article_changed': 'Šifre novih artikla',
    'label_change_for': 'Zamena',
    'label_success_open_door': 'Uspešno otverena vrata',
    'scanner_control': 'Kontrola skenera',
    'scanner_focus': 'Skener je u fokusu',
    'scanner_not_focus': 'Skener NIJE u fokusu',
    'focus_scanner': 'Fokusiraj skener',
    'last_scanned_user': 'Poslednji očitan korisnik',
    'scanning_in_progress': 'Skeniranje u toku',
    'label_add_on_current_state_trainings': 'Saberi termine sa trenutnim stanjem?',
    'label_si_all': 'Sve',
    'label_si_sell': 'Prodaja',
    'label_si_buy': 'Kupovina',
    'label_si_purchase': 'Nabavka',
    'label_si_additional_cost': 'Trošak',
    'label_timed_slots': 'Vremenski slotovi',
    'label_are_you_sure_delete_timed_slot': 'Da li ste sigurni da želite da obrišete',
    'label_timed_slot_success_delete': 'Uspešno obrisano',
    'label_are_you_sure_checkout_timed_slot': 'Da li ste sigurni da želite da odjavite',
    "label_timed_slot_name": "Naziv resursa",
    "label_capacity": "Kapacitet",
    "label_start": "Start",
    "label_end": "Kraj",
    "label_checkout": "Odjava",
    "label_extend": "Produži",
    "label_no_active_guests": "Nema aktivnih gostiju.",
    "label_add_new_timed_slot": "Dodaj novi resurs",
    "label_capacity_progress": "Popunjenost",
    "label_expired": "Isteklo",
    "label_rest": "Preostalo",
    "label_choose_resource_for_check_in": "Izaberite resurs za prijavu korisnika.",
    "label_set_number_in_minutes": "Uneiste vrednost u minutama",
    "label_extended": "Produženo",
    "label_choose_shop_item": "Izaberi proizvod",
    "label_add_shop_item": "+ proizvod",
    "label_click_to_select_shop_item": 'izaberi',
    "label_shop_item": 'Proizvod',
    "label_ended": 'Odjavljen',
    "label_finished": 'Završeni',
    "label_article_is_new": 'Nov artikl?',
    "label_new_article": "nov",
    "label_used_article": "polovan",
    "label_article_condition": "Stanje",
    "label_kp_posted": "KP status",
    "label_kp_posted_yes": "Okačen na KP",
    "label_kp_posted_no": "Nije okačen",
    "label_filter_add_info_memory": "Dodatna memorija (tačno)",
    "label_filter_ram_memory": "RAM memorija (tačno)",
    "label_filter_color_partial": "Boja",
    "label_bar_pos": 'Šank',
    "label_quick_sell": 'Brza prodaja',
    "label_all": 'Sve',
    "label_bills": 'Računi',
    "label_cart": 'Korpa',
    "label_cart_items": 'Stavki',
    "label_cart_approve": 'Potvrdi',
    "label_cart_not_on_stock": 'Nema na stanju',
    "label_cart_added": 'Dodato',
    "label_shop_item_state": 'Stanje',
    "label_group_by_user": 'Grupiši po korisniku',
    "label_group_by_product": 'Grupiši po proizvodu',
    "label_sell_product": 'Prodato',
    "label_nothing_found": 'Nema stavki',
    "label_loading": 'Učitavanje...',
    "label_results": 'Rezultati',
    "label_user_type_personal": 'Personalni',
    "label_verify_are_you_sure": 'Verifikujte korisnika',
    "label_verify": 'Verifikuj',
    "label_registered": 'Registrovan',
    "label_sort_by": 'Sortiraj po',
    "label_direction": 'Smer sortiranja',
    "label_direction_up": 'Rastući',
    "label_direction_down": 'Opadajući',
    "label_created_at": 'Datum registracije',
    "label_last_activity": 'Vreme poslednje aktivnosti',
    "label_paid_date": 'Datum uplate',
    "label_expire_date": 'Datum isticanja',
    "label_membership_type": 'Tip plaćanja vidljiv na aplikaciji',
    "label_update_user_profile": 'Profil korisnika',
    "label_user_profile_details": 'Detalji naloga',
    "label_user_payment_details": 'Lista uplata',
    "label_add_sign_up_user": 'Prijavi korisnika',
    "label_membership_subscription": 'Pretplata',
    "label_membership_one_payment": 'Jednokratna uplata',
    "label_membership_both": 'Pretplata i jednokratna uplata',
    "label_subscriptions": 'Pretplate',
    "label_created_date": 'Datum kreiranja',
    "label_payment_next_charge": 'Sledeća naplata',
    "label_number_of_renewal": 'Broj obnavljanja',
    "label_ci_knowledge": 'Baza znanja',
    "label_ci_knowledge_add": 'Dodaj stavku',
    "label_ci_knowledge_name": 'Ime',
    "label_ci_knowledge_name_en": 'Ime (en)',
    "label_ci_knowledge_embeded_video_link": 'Embeded video link',
    "label_preview": 'Pregled',
    "label_copy_to_notification": 'Copy to notification',
    "label_cash_register": 'Kasa',
    "label_cash_current_state": 'Trenutno stanje',
    "bill_status_finished": 'Završeno',
    "bill_status_pending": 'Na čekanju',
    "label_simple_search": 'Jednostavna pretraga',
    "label_advanced_search": 'Detaljna pretraga',
    "label_create_custom_bill": 'Kreiraj račun',
    "label_fill_custom_bill": 'Kreiranjem ovog računa kasa će biti uvećana za iznos koji unesete',
    "label_bill_enter_name": 'Useite ime računa, npr. prodata specifična članarina...',
    "label_bill_enter_amount": 'Unesite iznos računa',
    "label_bill_optional_comment": 'Unesite komentar (opciono)',
    "label_save_bill": 'Sačuvaj račun',
    "label_cart_description": 'Klikom na neki proizvod dodajete ga u korpu',
    "label_cash_cashout": 'Izvadi iz kase',
    "label_fill_required_fields": "Obavezna polja su ime, ukupna suma i kategorija",
    "label_saving": "Molimo sačekajte",
    "bill_status_from_canceled": "Od storniranog",
    "bill_status_canceled": "Stornirano",
    "label_bill_cancel": "Storniraj",
    "label_storn_bill_description": "Da li ste sigurni da želite da stornirate račun",
    "label_shop_category_shop": "Prodavnica",
    "label_shop_category_membership": "Članarina",
    "label_shop_category_all": "Sve",
    "label_discount": "Popust",
    "label_insert_discount": "Unesite popust (0-100) %",
    "label_amount_with_discount": "Ukupno sa popustom",
    "label_discount_desc_error": "Popust može da bude izmedju 0 - 100",
    "label_articles_report_not_permit": "Nemate pristup izveštaju",
    "label_not_permit_action": "Nemate prava na ovu akciju",
    "label_show_inventory": "Prikaži popis filter",
    "label_hide_inventory": "Sakrij popis filter",
    "label_last_inventory": "Na popisu",
    "label_last_inventory_label": "Poslednji popis",
    "label_last_inventory_update": "Ažuriraj",
    "label_last_inventory_update_label": "Ažuriraj popis",
    "label_are_you_sure_to_update_inventory": "Da li želite da ažurirate popis za",
    "label_article_inventory_success": "Uspešno ažuriran popis",
    "label_are_you_sure_to_update_inventory_not_in_stock": "ARTIKL NIJE NA STANJU! Prilikom ažuriranja popisa dodaće se na stanje",
    "label_warehouse": "Magacin",
    "label_warehouse_items_title": "Stavke magacina",
    "label_warehouse_item_add_title": "Dodavanje stavke magacina",
    "label_warehouse_item_edit_title": "Izmena stavke magacina",
    "label_inventory_history": "Istorija popisa",
    "label_inventory_history_subtitle": "Lista sačuvanih popisa",
    "label_inventory": "Popis",
    "label_create_inventory": "Napravi popis",
    "label_inventory_add_title": "Novi popis",
    "label_inventory_add_subtitle": "Unesi popisanu količinu za svaki artikal",
    "label_current_stock_number": "Trenutno stanje",
    "label_inventory_quantity": "Popisana količina",
    "label_confirm_inventory": "Potvrdi popis",
    "label_inventory_changed_items": "Izmenjene stavke",
    "label_inventory_saved": "Popis je uspešno sačuvan",
    "label_inventory_no_changes": "Nema izmenjenih stavki za čuvanje",
    "label_inventory_invalid_quantity": "Količina mora biti ceo broj veći ili jednak 0",
    "label_note": "Napomena",
    "label_stock_number": "Količina za dodavanje",
    "label_company_info_id": "ID kompanije",
    "label_add": "Dodaj",
    "label_no_data": "Nema podataka",
    "label_success_delete": "Uspešno obrisano",
    "label_all_field_required": "Sva obavezna polja moraju biti popunjena",
    "label_are_you_sure_delete": "Da li ste sigurni?",
    "label_are_you_sure_delete_desc": "Da li ste sigurni da želite da obrišete stavku",
    "label_purchase_price": "Nabavna cena",
    "label_pay_with_credits": "Naplati kreditima",
    "label_paid_with_credits": "Plaćeno kreditima",
    "label_paid_with": "Plaćeno",
    "label_cash": "Gotovina",
    "label_card": "Kartica",
    "label_online_card": "Online kartica",
    "label_bar_pos_debt": "Neplaceno",
    "label_pay_bill_description": "Racun će biti postavljen kao plaćen",
    "label_waiting_list_active": "Aktivni",
    "label_waiting_list_active_one": "Aktivan",
    "label_waiting_list_waiting": "Na čekanju",
    "label_waiting_list_expired": "Istekli",
    "label_profit":"Profit",
    "label_period":"Period",
    "label_total_profit":"Ukupan profit",
    "label_items_count":"Stavki",
    "label_show":"Prikaži",
    "label_no_profit_data_for_period":"Nema podataka za izabrani period",
    "label_profit_tab_orders":"Prodavnica",
    "label_profit_tab_payments":"Članarine",
    "label_total_reservations":"Ukupno zakazivanja",
    "label_most_popular_term":"Najpopularniji termin",
    "label_most_popular_term_reservations":"Zakazivanja najpopularnijeg",
    "label_most_popular_terms":"Najpopularniji termini",
    "label_term_occupancy":"Popunjenost termina",
    "label_full_terms":"Puni termini",
    "label_no_data_for_period":"Nema podataka za period",
    "label_no_weekly_report_data":"Nema podataka za nedeljni izveštaj",
    "label_weekly_report_title":"Nedeljni izveštaj",
    "label_entrance_total":"Ukupno ulaza",
    "label_entrance_most_popular_time":"Najpopularnije vreme",
    "label_entrance_count_then":"Broj ulaza tada",
    "label_entrance_by_bucket":"Ulazi po",
    "label_no_entrance_data_for_period":"Nema ulaza za izabrani period",
    "label_hour":"sat",
    "label_time_bucket":"vremenski bucket",
    "label_toggle_navigation_menu":"Prikaži/sakrij navigacioni meni",
    "label_close_navigation_menu":"Zatvori navigacioni meni",
    "label_light_theme":"Svetla tema",
    "label_dark_theme":"Tamna tema",
    "label_expand_sidebar":"Proširi bočni meni",
    "label_collapse_sidebar":"Skupi bočni meni",
    "label_switch_to_topbar":"Prebaci meni gore",
    "label_switch_to_sidebar":"Vrati meni levo",
    "label_reserving_training":"Rezervisanje treninga...",
    "label_canceling_training":"Otkazivanje treninga...",
    "label_no_trainer":"Bez trenera",
    "label_no_type":"Bez tipa",
    "label_waiting_list_title":"Lista čekanja",
    "label_user_report": "Izveštaj korisnika",
    "label_total_registrations":"Ukupno registracija",
    "label_total_deleted_users":"Ukupno obrisanih korisnika",
    "label_expiring_this_month":"Ističe ovog meseca",
    "label_avg_renewal_rate":"Prosečna stopa obnove članarine",
    "label_registrations_vs_deleted":"Registracije vs obrisani",
    "label_registrations":"Registracije",
    "label_deleted_users":"Obrisani korisnici",
    "label_renewal":"Obnove članarina",
    "label_expired_users":"Istekli korisnici",
    "label_not_renewed_users":"Korisnici bez obnove u 30 dana",
    "label_renewal_rate":"Stopa obnove članarine",
    "label_cohort_retention":"Zadržavanje po mesecu registracije",
    "label_cohort_month":"Mesec registracije",
    "label_cohort_size":"Broj korisnika u grupi",
    "label_m1_active":"Aktivni posle 1 meseca",
    "label_m2_active":"Aktivni posle 2 meseca",
    "label_m3_active":"Aktivni posle 3 meseca",
    "label_invalid_date_range":"Neispravan opseg datuma",
    "label_bar_saldo_debtors": "Šank dužnici",
};

let T_AR = {
    "day_monday": "الإثنين",
    "day_tuesday": "الثلاثاء",
    "day_wednesday": "الأربعاء",
    "day_thursday": "الخميس",
    "day_friday": "الجمعة",
    "day_saturday": "السبت",
    "day_sunday": "الأحد",
    "day_monday_short": "الإثنين",
    "day_tuesday_short": "الثلاثاء",
    "day_wednesday_short": "الأربعاء",
    "day_thursday_short": "الخميس",
    "day_friday_short": "الجمعة",
    "day_saturday_short": "السبت",
    "day_sunday_short": "الأحد",
    "month_short_january": "ينا",
    "month_short_february": "فبر",
    "month_short_march": "مار",
    "month_short_april": "أب",
    "month_short_may": "ماي",
    "month_short_june": "يون",
    "month_short_july": "يول",
    "month_short_august": "أغس",
    "month_short_september": "سبت",
    "month_short_october": "أكت",
    "month_short_november": "نوف",
    "month_short_december": "ديس",
    "month_january": "يناير",
    "month_february": "فبراير",
    "month_march": "مارس",
    "month_april": "أبريل",
    "month_may": "مايو",
    "month_june": "يونيو",
    "month_july": "يوليو",
    "month_august": "أغسطس",
    "month_september": "سبتمبر",
    "month_october": "أكتوبر",
    "month_november": "نوفمبر",
    "month_december": "ديسمبر",
    "t_my_trainings": "تدريباتي",
    "t_debtor": "مدين",
    "t_free": "مجاني",
    "t_free_single": "مجاني",
    "t_see_all": "(عرض الكل)",
    "t_active": "نشط",
    "t_deactive": "غير نشط",
    "t_reserve": "احجز",
    "t_cancel": "إلغاء",
    "t_waiting_list": "قائمة الانتظار",
    "t_waiting_list_cancel": "إلغاء الانتظار",
    "label_home": "الصفحة الرئيسية",
    "label_trainings": "التدريبات",
    "label_trainings_report": "تقرير التدريبات",
    "label_users": "المستخدمين",
    "label_bar_balance": "رصيد البار",
    "label_balance_history": "سجل الرصيد",
    "label_balance_adjustment": "تعديل يدوي",
    "label_balance_add": "إضافة",
    "label_balance_subtract": "خصم",
    "label_balance_updated": "تم تحديث الرصيد بنجاح",
    "label_balance_amount_required": "المبلغ مطلوب",
    "label_balance_amount_invalid": "المبلغ يجب أن يحتوي على منزلتين عشريتين كحد أقصى",
    "label_balance_amount_zero": "لا يمكن أن يكون المبلغ صفرًا",
    "label_balance_note_required": "الملاحظة مطلوبة",
    "label_balance_source_bill_create": "رسوم فاتورة البار",
    "label_balance_source_bill_cancel_return": "استرجاع (إلغاء الفاتورة)",
    "label_balance_source_bill_mark_paid": "تم تعليم الفاتورة كمدفوعة",
    "label_balance_source_mobile_app_credit_use": "منتج تم شراؤه عبر التطبيق",
    "label_balance_source_admin_adjustment": "تعديل يدوي من الإدارة",
    "label_balance_change_debit": "خصم",
    "label_balance_change_credit": "إضافة",
    "label_balance_users_report": "تقرير رصيد المستخدمين",
    "label_only_non_zero_balances": "يتم عرض المستخدمين ذوي الرصيد غير الصفري فقط",
    "label_history": "السجل",
    "label_actions": "الإجراءات",
    "label_add_subtract": "إضافة/خصم",
    "label_type": "النوع",
    "label_source": "المصدر",
    "label_before": "قبل",
    "label_after": "بعد",
    "label_terms": "الشروط",
    "label_notifications": "الإشعارات",
    "label_payments": "المدفوعات",
    "label_partners": "الشركاء",
    "label_companies": "الشركات",
    "label_membership": "العضوية",
    "label_account": "الحساب",
    "label_logout": "تسجيل الخروج",
    "label_login": "تسجيل الدخول",
    "label_payment_expires_today": "تنتهي العضوية اليوم",
    "label_payment_already_expires": "انتهت العضوية بالفعل",
    "label_please_extend_membership": "يرجى تجديد العضوية.",
    "label_success": "نجاح",
    "label_error": "خطأ",
    "label_enter_company_code": "يرجى إدخال رمز الشركة.",
    "label_company_code": "رمز الشركة",
    "label_company_code_loading": "جار التحميل...",
    "label_company_code_confirm": "تأكيد",
    "label_choose_company_code": "اختر الشركة",
    "label_company_not_exist": "الشركة غير موجودة.",
    "label_training_success_reserved": "تم حجز التدريب بنجاح.",
    "label_user_not_exist": "المستخدم غير موجود.",
    "label_please_wait": "يرجى الانتظار",
    "label_no_data_notifications": "لا توجد إشعارات جديدة",
    "label_download_app": "قم بتنزيل التطبيق بالنقر على الأيقونة",
    "label_not_now": "ليس الآن",
    "label_are_you_sure": "هل أنت متأكد؟",
    "label_are_you_sure_delete_notification": "هل أنت متأكد أنك تريد حذف الإشعار؟",
    "label_yes": "نعم",
    "label_no": "لا",
    "label_primary": "رئيسية",
    "label_set_as_primary": "تعيين كصورة رئيسية",
    "label_add_photos": "أضف صورًا",
    "label_add_photos_hint": "انقر لرفع معرض صور المنتج",
    "label_uploading": "جارٍ الرفع...",
    "label_main_image_thumb": "رئيسية",
    "label_cannot_set_primary": "تعذر تعيين الصورة الرئيسية.",
    "label_kp_confirm_update": "هل أنت متأكد أنك تريد تعديل إعلان KP؟",
    "label_kp_confirm_park": "هل أنت متأكد أنك تريد إيقاف إعلان KP مؤقتًا؟",
    "label_kp_confirm_unpark": "هل أنت متأكد أنك تريد تفعيل إعلان KP؟",
    "label_kp_confirm_delete": "هل أنت متأكد أنك تريد حذف إعلان KP؟",
    "label_kp_share_url_copied": "تم نسخ الرابط.",
    "label_kp_share_url_missing": "رابط المشاركة فارغ.",
    "label_kp_gallery_panel": "KP + المعرض",
    "label_kp_section_title": "KupujemProdajem",
    "label_kp_ad_id": "معرف إعلان KP",
    "label_kp_share_url": "رابط المشاركة",
    "label_kp_click_to_copy": "انقر للنسخ",
    "label_kp_copy": "نسخ",
    "label_kp_loading_categories": "جارٍ تحميل الفئات...",
    "label_kp_loading_groups": "جارٍ تحميل المجموعات...",
    "label_kp_category": "الفئة",
    "label_kp_group": "المجموعة",
    "label_kp_group_suggest_text": "نص اقتراح المجموعة",
    "label_kp_type": "النوع",
    "label_kp_condition": "الحالة",
    "label_kp_price": "السعر",
    "label_kp_currency": "العملة",
    "label_kp_price_text": "نص السعر",
    "label_kp_contact_placeholder": "اتصال",
    "label_kp_post_date": "تاريخ النشر",
    "label_kp_ad_age": "عمر الإعلان",
    "label_kp_more_details": "تفاصيل أكثر",
    "label_kp_less_details": "تفاصيل أقل",
    "label_kp_immediate_available": "متاح فورًا",
    "label_kp_exchange": "استبدال",
    "label_kp_price_fixed": "سعر ثابت",
    "label_kp_local_pickup": "استلام شخصي",
    "label_kp_courier_delivery": "توصيل عبر شركة شحن",
    "label_kp_description_html": "الوصف (HTML)",
    "label_kp_editor_bold": "عريض",
    "label_kp_editor_italic": "مائل",
    "label_kp_action_publish_loading": "جارٍ نشر الإعلان...",
    "label_kp_action_update_loading": "جارٍ تعديل الإعلان...",
    "label_kp_action_park_loading": "جارٍ إيقاف الإعلان مؤقتًا...",
    "label_kp_action_unpark_loading": "جارٍ تفعيل الإعلان...",
    "label_kp_action_unlink_loading": "جارٍ فصل الإعلان...",
    "label_kp_action_delete_loading": "جارٍ حذف الإعلان...",
    "label_kp_action_processing": "جارٍ المعالجة...",
    "label_kp_publish": "انشر على KP",
    "label_kp_update": "تعديل الإعلان",
    "label_kp_park": "إيقاف الإعلان مؤقتًا",
    "label_kp_unpark": "تفعيل الإعلان",
    "label_kp_unlink": "فصل عن KP",
    "label_kp_delete": "حذف إعلان KP",
    "label_upload_failed": "فشل الرفع.",
    "label_are_you_sure_delete_image": "هل أنت متأكد أنك تريد حذف الصورة؟",
    "label_delete_image_failed": "فشل حذف الصورة.",
    "label_save_image_order": "حفظ ترتيب الصور",
    "label_image_order_saved": "تم حفظ ترتيب الصور.",
    "label_image_order_save_failed": "فشل حفظ ترتيب الصور.",
    "label_download_all_images_zip": "تنزيل كل الصور (ZIP)",
    "label_click_image_to_zoom": "انقر على الصورة للتكبير",
    "label_kp_save_article_before_publish": "احفظ المنتج قبل نشره على KP.",
    "label_kp_publish_success": "تم نشر إعلان KP.",
    "label_kp_publish_error": "خطأ أثناء نشر إعلان KP.",
    "label_kp_save_article_before_update": "احفظ المنتج قبل تعديل إعلان KP.",
    "label_kp_update_success": "تم تعديل إعلان KP.",
    "label_kp_update_error": "خطأ أثناء تعديل إعلان KP.",
    "label_kp_park_success": "تم إيقاف إعلان KP مؤقتًا.",
    "label_kp_park_error": "خطأ أثناء إيقاف إعلان KP مؤقتًا.",
    "label_kp_unpark_success": "تم تفعيل إعلان KP.",
    "label_kp_unpark_error": "خطأ أثناء تفعيل إعلان KP.",
    "label_kp_delete_success": "تم حذف إعلان KP.",
    "label_kp_delete_error": "خطأ أثناء حذف إعلان KP.",
    "label_kp_confirm_unlink": "سيؤدي هذا إلى حذف بيانات KP من قاعدة بياناتنا فقط. سيبقى الإعلان على KP نشطًا. متابعة؟",
    "label_kp_unlink_success": "تم حذف بيانات KP محليًا.",
    "label_kp_unlink_error": "حدث خطأ أثناء فصل بيانات KP.",
    "label_kp_fill_after_create_question": "هل تريد تعبئة بيانات KP الآن؟",
    "label_kp_fill_now": "تعبئة KP",
    "label_kp_post_new": "نشر إعلان جديد",
    "label_kp_import": "سحب",
    "label_kp_import_id_only": "ربط المعرف فقط",
    "label_kp_import_loading": "جارٍ السحب...",
    "label_kp_import_required": "معرف KP مطلوب.",
    "label_kp_import_invalid": "يجب أن يكون معرف KP رقمًا موجبًا.",
    "label_kp_import_success": "تم سحب إعلان KP بنجاح. عدد الصور المتزامنة",
    "label_kp_import_id_only_success": "تم ربط معرف KP بنجاح. لم يتم استيراد البيانات أو الصور.",
    "label_kp_import_error": "حدث خطأ أثناء سحب إعلان KP.",
    "label_kp_kind_goods": "سلع",
    "label_kp_kind_service": "خدمة",
    "label_kp_kind_job": "وظيفة",
    "label_kp_type_sell": "بيع",
    "label_kp_type_buy": "شراء",
    "label_kp_condition_new": "جديد",
    "label_kp_condition_as_new": "كالجديد",
    "label_kp_condition_used": "مستعمل",
    "label_kp_condition_damaged": "تالف",
    "label_cancel": "إلغاء",
    "label_success_delete_notification": "تم حذف الإشعار بنجاح",
    "label_add_term": "إضافة شرط",
    "label_see_terms": "عرض الشروط",
    "label_search": "بحث",
    "label_amount_terms": "إجمالي الشروط",
    "label_amount_trainings": "إجمالي الأعضاء",
    "label_show_my_trainings": "عرض تدريباتي فقط",
    "label_name": "الاسم",
    "label_surname": "اللقب",
    "label_date": "التاريخ",
    "label_time": "الوقت",
    "label_number_of_trainings": "عدد التدريبات",
    "label_number_of_not_arrived": "عدد الغائبين",
    "label_equipment": "المعدات",
    "label_success_add_training": "تم حجز التدريب بنجاح.",
    "label_success_remove_training": "تم إلغاء التدريب بنجاح.",
    "label_remove_training_title": "إلغاء التدريب",
    "label_remove_training_title_are_you_sure": "هل تريد إلغاء التدريب؟",
    "label_back_training": "إرجاع التدريب",
    "label_back_training_are_you_sure": "هل تريد إرجاع التدريب للمستخدم؟",
    "label_save": "حفظ",
    "label_save_order": "حفظ الترتيب",
    "label_drop_here": "أفلت هنا",
    "label_set_key": "تعيين المفتاح",
    "label_success_add_to_waiting_list": "تمت الإضافة بنجاح إلى قائمة الانتظار.",
    "label_success_remove_to_waiting_list": "تمت الإزالة بنجاح من قائمة الانتظار.",
    "label_remove_waiting_list": "إلغاء قائمة الانتظار",
    "label_remove_waiting_list_are_you_sure": "هل تريد إلغاء قائمة الانتظار؟",
    "label_my_trainings": "تدريباتي",
    "label_scheduled_trainings": "التدريبات المجدولة",
    "label_no_scheduled_trainings": "لا توجد تدريبات مجدولة",
    "label_waiting_list": "قائمة الانتظار",
    "label_waiting_list_is_empty": "قائمة الانتظار فارغة",
    "label_see_all_trainings": "العناصر",
    "label_view_terms_for_day": "عرض الشروط ليوم",
    "label_day": "اليوم",
    "label_training_type": "النوع",
    "label_training_type_title": "نوع التدريب",
    "label_max_people": "الحد الأقصى للأشخاص",
    "label_reserve_training": "احجز التدريب",
    "label_edit": "تعديل",
    "label_delete": "حذف",
    "label_deactivate": "تعطيل",
    "label_activate": "تفعيل",
    "label_reserve": "احجز",
    "label_are_you_sure_activate_term": "هل أنت متأكد أنك تريد تفعيل الشرط",
    "label_are_you_sure_deactivate_term": "هل أنت متأكد أنك تريد تعطيل الشرط",
    "label_are_you_sure_delete_term": "هل أنت متأكد أنك تريد حذف الشرط",
    "label_term_activated": "تم تفعيل الشرط بنجاح",
    "label_term_deactivated": "تم تعطيل الشرط بنجاح",
    "label_term_deleted": "تم حذف الشرط بنجاح",
    "label_edit_term": "تعديل الشرط",
    "label_term_success_updated": "تم تحديث الشرط بنجاح.",
    "label_term_success_saved": "تم إضافة الشرط بنجاح.",
    "label_send_notification": "إرسال إشعار",
    "label_add_user_to_term": "إضافة مستخدم إلى التدريب",
    "label_user_will_be_added_to_term": "سيتم إضافة هذا المستخدم إلى هذا الشرط",
    "label_some_user_expire_payment": "بالنسبة لبعض المستخدمين، انتهت صلاحية العضوية. يجب عليك تجديد العضوية أولاً.",
    "label_choose_user": "اختر المستخدم",
    "label_search_users": "البحث عن المستخدمين...",
    "label_username": "اسم المستخدم",
    "label_select": "اختر",
    "label_click_to_select_user": "انقر لاختيار المستخدم",
    "label_pagination_first": "الأول",
    "label_pagination_previous": "السابق",
    "label_pagination_next": "التالي",
    "label_pagination_last": "الأخير",
    "label_pagination_amount": "إجمالي العناصر",
    "label_from": "من",
    "label_to": "إلى",
    "label_do_search": "ابحث",
    "label_show_weekly_report": "عرض التقرير الأسبوعي",
    "label_amount": "الإجمالي",
    "label_currency": "دينار كويتي",
    "label_number_of_terms": "عدد الشروط",
    "label_average": "المعدل",
    "label_rest_trainings": "التدريبات المتبقية",
    "label_partner": "شريك",
    "label_add_user": "إضافة مستخدم",
    "label_users_show_only_debtor": "عرض المدينين فقط",
    "label_users_amount": "إجمالي المستخدمين",
    "label_serial_num": "الرقم التسلسلي",
    "label_paid": "مدفوع",
    "label_expire": "تاريخ الانتهاء",
    "label_payment_type": "نوع الدفع",
    "label_are_you_sure_to_delete_user": "هل أنت متأكد أنك تريد حذف المستخدم",
    "label_user_deleted_success": "تم حذف المستخدم بنجاح",
    "label_are_you_sure_to_add_training_to_user": "هل أنت متأكد أنك تريد إضافة التدريب إلى المستخدم",
    "label_are_you_sure_to_remove_training_to_user": "هل أنت متأكد أنك تريد إزالة التدريب من المستخدم",
    "label_training_removed_success": "تمت إزالة التدريب بنجاح",
    "label_training_add_success": "تمت إضافة التدريب بنجاح",
    "label_email": "البريد الإلكتروني",
    "label_phone": "الهاتف",
    "label_close": "إغلاق",
    "label_rest_of_trainings": "التدريبات المتبقية",
    "label_choose_trainings": "اختر التدريبات",
    "label_role": "دور",
    "label_role_user": "مستخدم",
    "label_role_trainer": "مدرب",
    "label_role_admin": "مدير",
    "label_choose": "اختيار",
    "label_current": "الحالي",
    "label_delete_trainer": "حذف",
    "label_user_added": "تمت إضافة المستخدم",
    "label_user_edited": "تم تحديث المستخدم",
    "label_update_user": "تحديث المستخدم",
    "label_reset_password": "إعادة تعيين كلمة المرور",
    "label_see_payments": "عرض المدفوعات",
    "label_are_you_sure_to_reset_password_to_user": "هل أنت متأكد أنك تريد إعادة تعيين كلمة المرور للمستخدم",
    "label_password_update": "تم تحديث كلمة المرور بنجاح",
    "label_picture": "صورة",
    "label_add_payment": "إضافة دفع",
    "label_payment_date": "تاريخ الدفع",
    "label_payment_expire_date": "تاريخ انتهاء الدفع",
    "label_payment_num_trainings": "عدد التدريبات",
    "label_payment_type_trainings": "نوع التدريب",
    "label_payment_money": "مبلغ الدفع",
    "label_payment_link_invoice": "رابط الفاتورة",
    "label_payment_for_company": "دفع للشركة",
    "label_payment_equipment": "معدات",
    "label_payment_error_choose_type": "اختر نوع التدريب",
    "label_payment_success_add": "تمت إضافة الدفع بنجاح",
    "label_payment_success_edit": "تم تعديل الدفع بنجاح",
    "label_edit_payment": "تعديل الدفع",
    "label_add_equipment": "إضافة معدات جديدة",
    "label_training_type_add": "إضافة نوع جديد",
    "label_payment_for": "دفع لـ",
    "label_payment_loyalty": "ولاء",
    "label_payment_add_new": "إضافة دفع",
    "label_payment_are_you_sure_to_delete": "هل أنت متأكد أنك تريد حذف الدفع؟",
    "label_edit_account": "تعديل الحساب",
    "label_success_edit_profile": "تم تعديل بيانات الملف الشخصي بنجاح.",
    "label_are_you_sure_to_delete_account": "هل أنت متأكد أنك تريد حذف الحساب؟ يمكنك استعادة حسابك بتسجيل الدخول مرة أخرى.",
    "label_success_deleted": "تم حذف الحساب بنجاح",
    "label_success_extend_payment": "تم تمديد العضوية بنجاح.",
    "label_active_payment": "عضوية نشطة",
    "label_history_payment": "تاريخ الدفع",
    "label_active_payment_expire": "العضوية صالحة حتى",
    "label_active_payment_price": "الدفع",
    "label_active_payment_tr_numbers": "عدد التدريبات المدفوعة",
    "label_active_payment_type": "نوع التدريب",
    "label_active_payment_rest": "المتبقي",
    "label_extend_payment": "تمديد العضوية",
    "label_history_payment_from": "صالح من",
    "label_history_payment_to": "إلى",
    "label_show_invoice": "عرض الفاتورة",
    "label_edit_profile": "تعديل الملف الشخصي",
    "label_change_password": "تغيير كلمة المرور",
    "label_delete_account": "حذف الحساب",
    "label_delete_account_success": "تم حذف الحساب بنجاح",
    "label_term_title": "الأوقات المحددة مسبقاً",
    "label_open_term": "فتح الأوقات",
    "label_add_new_type_trainings": "إضافة نوع تدريب جديد",
    "label_delete_searched_terms": "حذف الأوقات التي تم العثور عليها",
    "label_created_by": "تم إنشاؤه بواسطة",
    "label_are_you_sure_delete_found_terms": "هل أنت متأكد أنك تريد حذف الأوقات التي تم العثور عليها؟",
    "label_terms_deleted_success": "تم حذف الأوقات بنجاح",
    "label_term_deleted_success": "تم حذف الوقت بنجاح",
    "label_add_notification": "إضافة إشعار",
    "label_notification_priority": "الأولوية",
    "label_notification_low": "منخفضة",
    "label_notification_medium": "متوسطة",
    "label_notification_high": "عالية",
    "label_link": "رابط",
    "label_choose_days": "اختر الأيام",
    "label_term_add_user_to_term": "إضافة مستخدم إلى الوقت",
    "label_term_user_will_be_added": "سيتم إضافته إلى هذا الوقت",
    "label_term_choose_at_least_day": "يجب عليك اختيار يوم واحد على الأقل.",
    "label_term_added_success": "تمت إضافة الوقت بنجاح",
    "label_term_edit_term": "تعديل الوقت",
    "label_term_edit_term_success": "تم تعديل الوقت بنجاح",
    "label_open_trainings_for": "فتح التدريبات لـ",
    "label_open_trainings_for_desc": "إذا تركت التاريخ فارغاً، سيتم إنشاء الأوقات لـ",
    "label_open_trainings_success": "تم فتح أوقات التدريب بنجاح",
    "label_count_payments": "عدد المدفوعات",
    "label_add_partner": "إضافة",
    "label_name_of_partner": "اسم الشريك",
    "label_partner_add_title": "إضافة شريك",
    "label_partner_edit_title": "تعديل الشريك",
    "label_partner_all_field_required": "يجب عدم ترك الحقول فارغة",
    "label_old_password": "كلمة المرور القديمة",
    "label_new_password": "كلمة المرور الجديدة",
    "label_repeat_password": "إعادة إدخال كلمة المرور",
    "label_password_error_not_empty": "كلمة المرور الجديدة لا يمكن أن تكون فارغة",
    "label_password_error_old_password_not_empty": "كلمة المرور القديمة لا يمكن أن تكون فارغة",
    "label_password_error_repeat_same_password": "كرر نفس كلمة المرور",
    "label_password_success_changed": "تم تغيير كلمة المرور بنجاح",
    "label_password": "كلمة المرور",
    "label_do_login": "تسجيل الدخول",
    "label_no_data_trainings": "لا توجد أماكن للتاريخ المحدد",
    "label_no_membership": "لا توجد عضوية نشطة",
    "label_no_membership_history": "لا توجد مدفوعات تاريخية",
    "label_input_serbian": "أدخل النص باللغة العربية",
    "label_input_title_serbian": "أدخل العنوان باللغة الصربية",
    "label_input_english": "أدخل النص باللغة الإنجليزية (اختياري)",
    "label_input_title_english": "أدخل العنوان باللغة الإنجليزية (اختياري)",
    "label_load_image": "تحميل الصورة",
    "label_edit_picture": "تعديل الصورة",
    "label_max_size_picture": "أقصى حجم للصورة هو 5 ميجابايت",
    "label_image_upload_error": "خطأ أثناء تحميل الصورة.",
    "label_edit_notification": "تعديل الإشعار",
    "label_notification_empty": "لا يمكن أن يكون الإشعار فارغاً!",
    "label_notification_title_empty": "لا يمكن أن يكون عنوان الإشعار فارغاً!",
    "label_notification_add_success": "تمت إضافة الإشعار بنجاح",
    "label_notification_edit_success": "تم تعديل الإشعار بنجاح",
    "label_open_terms_for_current_week": "فتح الأوقات للأسبوع الحالي",
    "label_training_history": "تاريخ التدريب",
    "label_training_history_is_empty": "تاريخ التدريب فارغ",
    "label_created_edited": "تم الإنشاء/التعديل بواسطة",
    "label_user_training_type": "نوع الدفع",
    "label_training_key": "إضافة مفتاح",
    "label_add_key": "إضافة مفتاح",
    "label_max_people_on_training": "عدد الأشخاص في التدريب",
    "label_name_for_partner": "مدرب",
    "label_mp_title": "حزم العضوية",
    "label_mp_name": "اسم الحزمة",
    "label_mp_add": "إضافة حزمة",
    "label_mp_during_in_days": "مدة الحزمة بالأيام",
    "label_mp_price": "سعر الحزمة",
    "label_membership_are_you_sure_to_delete": "هل أنت متأكد أنك تريد حذف الحزمة؟",
    "label_birthday": "تاريخ الميلاد",
    "label_payment_paid_date": "تاريخ الدفع",
    "label_loyalty": "ولاء",
    "label_success_delete_payment": "تم حذف الدفع بنجاح",
    "label_buy_membership": "شراء العضوية",
    "label_buy_membership_from_date": "شراء العضوية من التاريخ",
    "label_please_select_date": "يرجى تحديد تاريخ بدء صلاحية العضوية",
    "label_success_bought_membership": "لقد اشتريت العضوية بنجاح.",
    "label_current_busy": "الازدحام الحالي في الصالة الرياضية",
    "label_invoices": "الفواتير",
    "label_invoices_created_successfully": "تم إنشاء الفاتورة(ات) بنجاح",
    "label_created": "تم الإنشاء",
    "label_paid_yes": "نعم",
    "label_paid_no": "لا",
    "label_number_user_for_invoice": "المستخدمون المفوترون",
    "label_set_paid": "تحديد كمدفوع",
    "label_current_balance": "الرصيد الحالي",
    "label_invoice_are_you_sure_to_delete": "هل أنت متأكد أنك تريد حذف الفاتورة؟",
    "label_add_invoice": "إضافة فاتورة",
    "label_invoice_create_all_confirm": "هل أنت متأكد أنك تريد إنشاء فواتير لجميع الشركات؟",
    "label_invoice_item_price": "سعر العنصر",
    "label_invoice_item_count": "الكمية",
    "label_invoice_type": "نوع الفاتورة",
    "label_invoice_all_field_required": "جميع الحقول مطلوبة",
    "label_add_invoice_all": "إنشاء فواتير للجميع",
    "label_invoice_report": "تقرير الفواتير",
    "label_monthly_turnover": "الدوران الشهري",
    "label_turnover_by_company": "الدوران حسب الشركة",
    "label_total_turnover": "إجمالي الدوران",
    "label_debtors": "المدينون",
    "label_debtors_list": "قائمة المدينين",
    "label_no_minus_invoices_for_period": "لا توجد فواتير سالبة للفترة المحددة",
    "label_no_permission_for_report": "ليس لديك صلاحية لهذا التقرير",
    "label_download_pdf": "تحميل PDF",
    "label_pdf": "PDF",
    "label_category_membership": "الفئة (اختياري)",
    "label_add_category_membership": "إضافة فئة جديدة",
    "label_insert_name_category_membership": "أدخل اسم الفئة",
    "label_mp_category": "الفئة",
    "label_ci_training_add": "إضافة تدريب جديد",
    "label_ci_training_name": "اسم التدريب",
    "label_ci_training_name_en": "اسم التدريب (بالإنجليزية)",
    "label_ci_training_short_desc": "وصف قصير",
    "label_ci_training_short_desc_en": "وصف قصير (بالإنجليزية)",
    "label_ci_training_long_desc": "وصف طويل",
    "label_ci_training_long_desc_en": "وصف طويل (بالإنجليزية)",
    "label_ci_training_image": "الصورة",
    "label_ci_training_choose_image": "اختيار صورة",
    "label_ci_training_kcal": "السعرات الحرارية المحروقة",
    "label_ci_training_minutes": "مدة التدريب بالدقائق",
    "label_ci_training_intensity": "شدة التدريب (0 - 5)",
    "label_ci_training_required": "مطلوب: الاسم، الوصف القصير، الوصف الطويل، الصورة",
    "label_ci_training_success_add": "تم إضافة التدريب بنجاح",
    "label_ci_training_are_you_sure": "هل أنت متأكد أنك تريد حذف: ",
    "label_trainers": "المدربون",
    "label_ci_trainer_add": "إضافة مدرب جديد",
    "label_user_added_success_add_payment": "تم إضافة المستخدم بنجاح! هل ترغب في إضافة الدفع الأول له؟",
    "label_set_trainings_number": "تحديد عدد التدريبات",
    "label_ci_nutrition_add": "إضافة تغذية جديدة",
    "label_ci_nutrition": "التغذية",
    "label_ci_nutrition_name": "اسم التغذية",
    "label_ci_nutrition_name_en": "اسم التغذية (بالإنجليزية)",
    "label_ci_nutrition_short": "وصف قصير",
    "label_ci_nutrition_short_en": "وصف قصير (بالإنجليزية)",
    "label_ci_nutrition_long": "وصف أطول",
    "label_ci_nutrition_long_en": "وصف أطول (بالإنجليزية)",
    "label_articles": "المقالات",
    "label_on_waiting": "في الانتظار",
    "label_amount_articles": "إجمالي عدد المقالات",
    "label_a_name": "الاسم",
    "label_a_category": "الفئة",
    "label_a_sub_category": "الفئة الفرعية",
    "label_a_memory": "الذاكرة",
    "label_a_purchase_price": "سعر الشراء",
    "label_a_selling_price": "سعر البيع",
    "label_a_desc": "الوصف",
    "label_a_comment": "تعليق",
    "label_add_article": "إضافة مقال",
    "label_a_stock": "الكمية",
    "label_a_statuses": "الحالة",
    "label_a_statuses_show": "عرض الإجراءات",
    "label_article_added": "تمت إضافة المقال بنجاح",
    "label_article_updated": "تم تحديث المقال بنجاح",
    "label_a_stock_number": "الكمية",
    "label_a_stock_number_set": "تحديد الكمية",
    "label_update_article": "تحديث المقال",
    "label_are_you_sure_to_remove_article": "هل أنت متأكد أنك تريد حذف المقال؟",
    "label_are_you_sure_to_remove_category": "هل أنت متأكد أنك تريد حذف الفئة؟",
    "label_article_removed_success": "تم حذف المقال بنجاح",
    "label_a_code": "الكود",
    "label_a_c_add": "إضافة الفئات",
    "label_a_c_add_sub_for": "إضافة فئة فرعية لـ",
    "label_a_c": "الفئات",
    "label_a_c_sub": "الفئة الفرعية",
    "label_a_c_see_sub": "عرض الفئات الفرعية",
    "label_back_to_all_categories": "العودة لجميع الفئات",
    "label_show_filters": "عرض الفلاتر",
    "label_clear_filters": "مسح الفلاتر",
    "label_a_c_edit_sub_for": "تحرير الفئة الفرعية لـ",
    "label_a_c_name": "إضافة فئة",
    "label_choose_imei": "اختيار IMEI",
    "label_crop_image": "قص الكود",
    "label_article_approve": "الموافقة",
    "label_article_approved_success": "تمت الموافقة بنجاح",
    "label_are_you_sure_to_approve_article": "هل أنت متأكد من أنك تريد الموافقة على",
    "label_article_all": "الجميع",
    "label_article_for_approve": "للموافقة",
    "label_article_active": "نشط",
    "label_article_service": "في الخدمة",
    "label_article_sold": "تم البيع",
    "label_article_waiting_approve": "بانتظار الموافقة",
    "label_imei_error": "IMEI يجب أن يحتوي على 15 رقمًا بالضبط",
    "label_serial_number_error": "لا يجب أن يكون فارغًا",
    "label_are_you_sure_to_add_to_stock": "هل أنت متأكد أنك تريد إضافة للمخزون",
    "label_are_you_sure_to_remove_to_stock": "هل أنت متأكد أنك تريد إزالة من المخزون",
    "label_article_add_to_stock": "إضافة للمخزون",
    "label_article_remove_to_stock": "تم البيع",
    "label_buy_date": "تاريخ الشراء",
    "label_article_already_exist": "المقال موجود بالفعل",
    "label_article_are_you_sure_update_already": "هل تريد تحديث المقال الموجود؟",
    "label_ci_shop": "المتجر",
    "label_ci_shop_add": "إضافة منتج",
    "label_ci_shop_name": "اسم المنتج",
    "label_ci_shop_name_en": "اسم المنتج (بالإنجليزية)",
    "label_ci_shop_short_desc": "وصف قصير",
    "label_ci_shop_short_desc_en": "وصف قصير (بالإنجليزية)",
    "label_ci_shop_long_desc": "وصف طويل",
    "label_ci_shop_long_desc_en": "وصف طويل (بالإنجليزية)",
    "label_ci_shop_success_add": "تمت إضافة المنتج بنجاح",
    "label_ci_shop_price": "السعر",
    "label_ci_shop_currency": "العملة",
    "label_ci_mobile_settings": "التطبيق",
    "label_ci_header_image": "صورة الرأس في الصفحة الرئيسية للتطبيق",
    "label_ci_header_image_uploaded_success": "تم رفع صورة الرأس",
    "label_ci_header_photo_delete_are_you_sure": "هل أنت متأكد أنك تريد إزالة صورة الرأس من التطبيق؟",
    "label_ci_header_image_deleted_success": "تمت إزالة صورة الرأس بنجاح",
    "label_ci_header_image_info_desc_1": "صورة الرأس للتطبيق",
    "label_ci_header_image_info_desc_2": "ستظهر هذه الصورة للمستخدمين في الصفحة الرئيسية",
    "label_a_color": "اللون",
    "label_internal_code": "الكود الداخلي",
    "label_search_internal_code": "البحث بالكود الداخلي",
    "label_see_colors": "عرض الألوان",
    "label_category_name": "الاسم",
    "label_add_new_color": "إضافة لون جديد",
    "label_show_personal_message": "عرض الرسائل المخصصة",
    "label_show_personal_message_desc": "إذا قمت بتحديد نوع، سيرى هذا الإشعار فقط المستخدمون الذين لديهم هذا النوع محدد أثناء الدفع",
    "label_show_sort": "الفرز",
    "label_clear_sort": "إخفاء الفرز",
    "label_sort_by_date": "الفرز حسب التاريخ",
    "label_sort_by_abs": "الفرز أبجديًا",
    "label_ci_trainer_name": "اسم المدرب",
    "label_ci_trainer_name_en": "اسم المدرب (بالإنجليزية)",
    "label_a_ram_memory": "ذاكرة RAM",
    "label_article_sent_by_post": "تم الإرسال بالبريد",
    "label_show_more": "عرض المزيد",
    "label_show_less": "عرض أقل",
    "label_not_active_more": "غير نشط لأكثر من",
    "label_not_active_more_3": "3 أشهر",
    "label_not_active_more_6": "6 أشهر",
    "label_price": "السعر",
    "label_success_update_waiting_list": "تم تحديث قائمة الانتظار بنجاح",
    "label_show_users_more": "عرض",
    "label_expire_payment_users": "عرض المستخدمين الذين انتهت عضويتهم",
    "label_active_users": "المستخدمين النشطين",
    "label_active_users_last_30_days": "المستخدمون النشطون في آخر 30 يومًا",
    "label_not_active_users": "المستخدمون غير النشطين",
    "label_article_archived": "أرشيفي",
    "label_are_you_sure_to_recovery_article": "هل أنت متأكد أنك تريد استعادة المقال",
    "label_article_recovered_success": "تم استعادة المقال بنجاح",
    "label_recovery": "استعادة",
    "label_ci_shop_discount": "خصم",
    "label_ci_position": "الترتيب في القائمة",
    "label_ci_position_desc": "إذا تركت 0 في هذا الحقل، سيتم إضافة العنصر كآخر عنصر في القائمة",
    "label_standard_payment": "الدفع القياسي",
    "label_additional_payment": "الخدمات الإضافية",
    "label_payment_types": "أنواع الدفع",
    "label_activate_all": "تفعيل الكل",
    "label_activate_all_desc": "هل تريد تفعيل جميع الشروط؟",
    "label_deactivate_all": "إلغاء تفعيل الكل",
    "label_deactivate_all_desc": "هل تريد إلغاء تفعيل جميع الشروط؟",
    "label_format_of_time_not_valid": "يجب أن يكون تنسيق الوقت كما يلي: HH:mm (مثال: 12:20)",
    "label_term_choose_at_least_time": "يجب عليك إضافة وقت واحد على الأقل. أضف الوقت من خلال إدخال الوقت المطلوب أولاً ثم النقر على + على الجانب الأيمن.",
    "label_important": "مهم",
    "label_qr_code_training_type": "إدخال رمز QR",
    "label_approved": "موافق عليه",
    "label_approve": "موافقة",
    "label_approve_are_you_sure": "هل أنت متأكد أنك تريد الموافقة على التدريب لـ:",
    "label_success_approved_training": "تمت الموافقة على التدريب بنجاح",
    "total_debt": "إجمالي الدين",
    "label_activate_all_filtered": "تفعيل الموجود",
    "label_deactivate_all_filtered": "إلغاء تفعيل الموجود",
    "label_deactivate_all_desc_filtered": "هل تريد إلغاء تفعيل الفتحات الموجودة؟",
    "label_activate_all_desc_filtered": "هل تريد تفعيل الفتحات الموجودة؟",
    "label_delete_and_cancel_all_users": "حذف وإلغاء جميع التدريبات",
    "label_success_added_user": "تمت إضافة المستخدم بنجاح",
    "label_success_qr_code_scan": "تسجيل الدخول بنجاح عبر رمز QR",
    "label_success_qr_code_scan_title": "تسجيل الدخول بنجاح",
    "label_success_qr_code_approve": "الموافقة بنجاح عبر رمز QR",
    "label_success_qr_code_approve_title": "تأكيد ناجح",
    "label_user": "مستخدم",
    "label_expire_payment_for_user": "انتهت صلاحية العضوية",
    "label_shop_link": "رابط من المتجر",
    "label_entrance": "مدخل QR",
    "label_entrance_success_reserved": "تم مسح الرمز بنجاح",
    "label_a_code_serial": "رقم التسلسل",
    "label_desc_training_filter_on_report": "*ملاحظة: فترة الوقت المحددة من القائمة تنطبق فقط على تاريخ البدء المختار",
    "label_choose_location": "اختر موقعًا: ",
    "label_choose_location_desc": "*ملاحظة: إذا لم تقم باختيار أي موقع، فسيكون العنصر مرئيًا في جميع المواقع",
    "label_quantity_for_buy": "الكمية للشراء",
    "label_quantity_for_buy_desc": "*عدد القطع التي سيشتريها المستخدم، مثال: تبيع 3 ألواح شوكولاتة بسعر مخفض، إذًا تدخل هنا 3",
    "label_buy": "اشترِ",
    "label_order": "اطلب",
    "label_are_you_sure_buy_item": "هل أنت متأكد أنك تريد شراء المنتج: ",
    "label_successfully_bought_item": "تم شراء المنتج بنجاح. يمكنك التحقق من حالة المنتج في محفظتك.",
    "label_are_you_sure_order_item": "هل أنت متأكد أنك تريد طلب المنتج: ",
    "label_successfully_ordered_item": "تم طلب المنتج بنجاح. يمكنك التحقق من حالة المنتج في محفظتك.",
    "label_tab_orders": "الطلبات",
    "label_orders_bought": "المنتجات المشتراة",
    "label_orders_used": "المنتجات المستعملة",
    "label_are_you_sure_cancel_order": "هل أنت متأكد أنك تريد إلغاء الطلب: ",
    "label_order_canceled_successfully": "هل أنت متأكد أنك تريد إلغاء الطلب: ",
    "label_user_wallet_quantity": "الكمية للإنفاق",
    "label_user_wallet_used": "تم الاستهلاك",
    "label_shop_qr": "رمز QR",
    "label_shop_qr_list": "قائمة QR",
    "label_enter_fullscreen": "دخول ملء الشاشة",
    "label_exit_fullscreen": "الخروج من ملء الشاشة",
    "label_fullscreen_failed": "تعذر تبديل وضع ملء الشاشة.",
    "label_are_you_sure_pay_user_wallet": "هل أنت متأكد أنك تريد تأكيد الدفع: ",
    "label_user_wallet_paid_successfully": "تم الدفع بنجاح",
    "label_action": "إجراء",
    "label_action_for_item": "إجراء للمنتج",
    "label_ci_shop_edit": "تعديل المنتج",
    "label_personal": "شخصي",
    "label_wod": "وود",
    "label_wod_program_display_error": "تعذر عرض البرنامج. يرجى المحاولة لاحقًا.",
    "label_add_td": "أضف تدريب جديد",
    "label_td_name": "اسم التدريب",
    "label_td_name_en": "اسم التدريب (en)",
    "label_td_short_desc": "وصف قصير",
    "label_td_short_desc_en": "وصف قصير (en)",
    "label_td_long_desc": "وصف طويل",
    "label_td_long_desc_en": "وصف طويل (en)",
    "label_delete_training_of_the_day_successfully": "تم حذف التدريب بنجاح",
    "label_delete_training_of_the_day": "حذف التدريب",
    "label_delete_training_of_the_day_are_you_sure": "هل أنت متأكد أنك تريد حذف التدريب",
    "label_success_added_training_of_the_day": "تم إضافة التدريب بنجاح",
    "label_choose_exist_training": "اختر تدريب موجود",
    "label_search_trainings_definition": "ابحث عن التدريبات",
    "label_edit_td": "تعديل التدريب",
    "label_success_edited_training_of_the_day": "تم تعديل التدريب بنجاح",
    "label_td_name_required": "الاسم مطلوب",
    "label_all_wod_trainings": "نظرة عامة على جميع التدريبات",
    "label_all_personal_trainings": "نظرة عامة على جميع التمارين",
    "label_all_wod_trainings_title": "نظرة عامة على جميع تدريبات WOD",
    "label_search_personal_trainings_definition": "بحث عن التمارين",
    "label_add_new_pt_exercise": "إضافة تمرين جديد",
    "label_td_pt_name": "اسم التمرين",
    "label_td_pt_video": "رابط الفيديو",
    "label_td_pt_name_en": "اسم التمرين (بالإنجليزية)",
    "label_td_pt_short_desc": "وصف قصير",
    "label_td_pt_short_desc_en": "وصف قصير (بالإنجليزية)",
    "label_td_pt_long_desc": "وصف طويل",
    "label_td_pt_long_desc_en": "وصف طويل (بالإنجليزية)",
    "label_video": "فيديو",
    "label_add_new_personal_program": "إضافة برنامج جديد",
    "label_personal_title": "برنامج شخصي",
    "label_pp_active": "برامج نشطة",
    "label_pp_not_active": "برامج غير نشطة",
    "label_pp_predefined_programs": "البرامج الجاهزة",
    "label_pp_name": "اسم البرنامج",
    "label_pp_name_en": "اسم البرنامج (بالإنجليزية)",
    "label_pp_from_date": "مدة البرنامج من",
    "label_pp_from_to": "مدة البرنامج إلى",
    "label_pp_choose_user": "اختر مستخدمًا للبرنامج",
    "label_pp_choose_user_or_partner": "اختر مستخدمًا أو شريكًا خارجيًا",
    "label_pp_success_saved": "تم حفظ البرنامج بنجاح",
    "label_pp_user_to_be_added": "سيتم إضافته إلى البرنامج",
    "label_pp_add_user_to_program": "اختر مستخدمًا للبرنامج",
    "label_delete_personal_program": "حذف البرنامج",
    "label_delete_personal_program_are_you_sure": "هل أنت متأكد أنك تريد حذف البرنامج؟",
    "label_delete_personal_program_successfully": "تم حذف البرنامج بنجاح",
    "label_edit_exercise": "تعديل التمارين",
    "label_edit_personal_program": "تعديل البرنامج",
    "label_pp_title": "برنامج شخصي",
    "label_all_the_exercises": "عرض جميع التمارين",
    "label_not_include_in_program": "غير مشمول",
    "label_my_active_program": "برامجي الحالية",
    "label_amount_purchase_price": "إجمالي سعر الشراء",
    "label_wod_type_training": "نوع",
    "label_wod_category_training": "فئة",
    "label_wod_coach_notes": "ملاحظة المدرب",
    "label_td_type": "نوع",
    "label_td_category": "فئة",
    "label_td_add_category": "أضف الفئة",
    "label_td_add_category_insert_name": "أدخل اسم الفئة الجديدة",
    "label_td_add_category_save_name": "احفظ الفئة الجديدة",
    "label_td_category_choose": "اختر الفئة",
    "label_td_category_choosed_delete": "احذف الفئة المختارة",
    "label_company_partners": "الشركاء الخارجيين",
    "label_number_of_people_for_company": "الحد الأقصى لعدد المستخدمين",
    "label_are_you_sure_delete_partner": "هل أنت متأكد؟",
    "label_are_you_sure_delete_partner_desc": "هل أنت متأكد أنك تريد الحذف",
    "label_partner_success_delete": "تم الحذف بنجاح.",
    "label_copy_program": "نسخ البرنامج",
    "label_copy_program_action": "نسخ",
    "label_assign_program_action": "تعيين",
    "label_without_company_partners": "بدون شريك خارجي",
    "label_personal_user": "المستخدم",
    "label_personal_company": "الشركة",
    'label_download_qr_code': 'تحميل كصورة',
    'label_pt_other_category': 'أخرى',
    'label_user_type_online': 'مستخدم عبر الإنترنت',
    'label_user_type_training_center': 'مركز التدريب',
    'label_user_type_both': 'عبر الإنترنت ومركز التدريب',
    'label_user_type': 'نوع المستخدم',
    "label_no_workouts": "حالياً ما في تمارين محددة",
    "label_no_active_programs": "حالياً ما في برنامج نشط",
    "label_view": "عرض البرنامج",
    'label_download_report': 'حمّل التقرير',
    'label_user_credit': 'رصيد الكاش باك',
    'label_add_credits': 'إضافة رصيد',
    'label_take_credits': 'خصم رصيد',
    'label_mp_action': 'هل الباقة على عرض؟',
    'label_choose_company': 'اختر شركتك',
    'label_documentations': 'توثيقات',
    "label_td_results_config": "إعداد النتائج",
    "label_td_add_measure_insert_name": "أدخل اسم القياس",
    "label_td_add_result_measure": "أضف قياس جديد",
    "label_td_measure_choose": "اختر قياس",
    "label_td_result_rounds": "عدد الجولات",
    "label_td_measure_choosed_delete": "احذف القياس المحدد",
    "label_result_repeat": "عدد التكرارات",
    "label_result_set": "مجموعة",
    "label_completed": "اكتمل",
    "label_change_my_result": "تعديل",
    "label_see_all_results": "جميع النتائج",
    "label_wod_results": "النتائج",
    "label_see_wod_as_user": "عرض الود كـ مستخدم",
    "label_training_type_are_you_sure_to_delete": "هل أنت متأكد أنك تريد الحذف",
    "label_success_update_training_types": "تم تحديث الأنواع بنجاح",
    "label_training_types": "أنواع التدريب",
    "label_trainer_name": "مدرب",
    'label_credit_active': 'نشط',
    'label_credit_history': 'منتهي',
    'label_credit_used': 'مستخدم',
    'label_are_you_sure_delete_user_credit': 'هل أنت متأكد؟',
    'label_are_you_sure_delete_user_credit_desc': 'هل أنت متأكد أنك تريد حذف الرصيد؟',
    'label_is_this_credit_type': 'هل هذا رصيد؟ (إذا اشترى المستخدم هذا، سيتم إضافته إلى رصيدهم)',
    'label_shoes_size': 'مقاس الحذاء',
    'label_us_type': 'نوع الرصيد',
    'label_us_amount': 'قيمة الرصيد',
    'label_us_amount_used': 'استخدام الرصيد',
    'label_us_created_date': 'تاريخ الإنشاء',
    'label_us_valid_to': 'صالح حتى',
    'label_lesson_url_ar': 'رابط الدرس',
    'label_user_additional_info_ar': 'معلومات إضافية عن المستخدم',
    'label_home_trainings': 'البرامج',
    'label_wod_total_result': 'خيارات للنتيجة الإجمالية',
    'label_td_total_result_choose': 'اختر القيمة',
    'label_wod_total_result_min': 'الحد الأدنى',
    'label_wod_total_result_max': 'الحد الأقصى',
    'label_wod_total_result_average': 'المتوسط',
    'label_wod_total_result_sum': 'المجموع',
    'label_wod_result_sort': 'طريقة ترتيب النتائج',
    'label_wod_result_sort_asc': 'تصاعدي (الأصغر هو الأفضل)',
    'label_wod_result_sort_desc': 'تنازلي (الأكبر هو الأفضل)',
    'label_total_result': 'النتيجة النهائية',
    'label_hide_details': 'إظهار أقل',
    'label_show_details': 'إظهار المزيد',
    "label_gender": "الجن",
    "label_gender_male": "ذكر",
    "label_gender_female": "أنثى",
    "label_choose_gender": "اختر الجنس للبحث",
    'label_gender_man': 'الرجال',
    'label_gender_woman': 'النساء',
    "label_copy_rd": "نسخ اليوم",
    "label_copy_training_desc": "اختر التواريخ التي تريد نسخ التدريب لها",
    "label_selected_dates": "التواريخ المختارة",
    "label_success_copy_trainings": "تم نسخ التدريبات بنجاح",
    'label_ci_events': 'الفعاليات',
    'label_ci_event_add': 'أضف فعالية',
    'label_ci_item_name': 'الاسم',
    'label_ci_item_name_en': 'الاسم (بالإنجليزية)',
    'label_ci_item_short_desc': 'وصف مختصر',
    'label_ci_item_short_desc_en': 'وصف مختصر (بالإنجليزية)',
    'label_ci_item_long_desc': 'وصف طويل',
    'label_ci_item_long_desc_en': 'وصف طويل (بالإنجليزية)',
    'label_ci_item_success_add': 'تم إضافة العنصر بنجاح',
    'label_ci_event_sign_up': 'سجل الآن',
    'label_ci_event_sign_up_edit': 'سجل الآن',
    'label_ci_event_fields': 'المعلومات المطلوبة',
    'label_ci_event_fields_add_new': 'أدخل معلومات جديدة',
    'label_ci_event_fields_add': 'أضف',
    'label_ci_event_all_users': 'جميع التسجيلات',
    'label_event_info': 'معلومات إضافية',
    'label_ci_max_signups': 'الحد الأقصى للتسجيل',
    'label_ci_event_successfully_sign_up': 'تم التسجيل بنجاح',
    'label_payment_comment': 'ملاحظات',
    "label_filter_day": "يوم",
    "label_filter_week": "أسبوع",
    "label_filter_month": "شهر",
    "label_filter_show": "عرض",
    "label_user_note_add": "أضف إلى اليوميات",
    "label_user_note_edit": "تعديل الملاحظة",
    "label_user_note_delete_desc": "هل أنت متأكد أنك تريد حذف الملاحظة؟",
    'label_schedule': 'الورديات',
    'label_budget': 'الميزانية',
    'label_schedule_start': 'ابدأ الوردية',
    'label_schedule_insert_money': 'تعيين المال',
    'label_schedule_inserted_money': 'تم التعيين',
    'label_schedule_are_you_sure_to_delete': 'هل أنت متأكد أنك تريد حذف الوردية؟',
    'label_success_delete_schedule': 'تم حذف الوردية بنجاح',
    'label_schedule_out_money': 'المبلغ المسلم',
    'label_status': 'الحالة',
    'label_schedule_active': 'مفتوحة',
    'label_schedule_finished': 'مغلقة',
    'label_schedule_lock': 'تأكيد الإغلاق',
    'label_approve_schedule_title': 'تأكيد الوردية',
    'label_approve_schedule': 'تأكيد',
    'label_close_schedule_title': 'إغلاق الوردية',
    'label_close_schedule': 'إغلاق',
    'label_schedule_inserted_money_current': 'الحالي',
    'label_schedule_item_cost': 'التكلفة/الربح',
    'label_plus': 'إضافة',
    'label_minus': 'خصم',
    'label_amount_in': 'المبلغ في',
    'label_article_for_change': 'رقم العنصر للاستبدال (6 أرقام)',
    'label_insert_profit': 'أدخل الربح',
    'label_comment': 'تعليق',
    'label_additional_cost_in': 'التكلفة الإضافية في',
    'label_download_training_data': 'تحميل التقرير',
    'label_training_report_title': 'تقرير التدريب',
    "label_additional_costs": "التكاليف الإضافية",
    "label_schedule_are_you_sure_to_approve": "هل أنت متأكد أنك تريد تأكيد الوردية؟",
    "label_success_approved_schedule": "تم تأكيد الوردية بنجاح",
    "label_edit_schedule_title": "تعديل الوردية",
    "label_add_amount": "إضافة مبلغ",
    "label_remove_amount": "إرجاع المبلغ",
    "label_article_for_change_title": "عنصر للتبديل (اختياري)",
    "label_send_message": "محتوى الرسالة",
    "label_title_message": "عنوان الحملة",
    "label_enter_email_title": "أدخل عنوان الرسالة",
    "label_enter_email_text": "أدخل نص الرسالة",
    "label_send_by_email": "أرسل عبر البريد الإلكتروني",
    "label_send_by_notification": "أرسل كإشعار",
    "label_send": "إرسال",
    "label_chat": "الدعم",
    "label_admin_chat": "الدعم",
    "label_user_chat": "الدعم",
    "label_conversations": "المحادثات",
    "label_no_conversations": "لا توجد محادثات",
    "label_messages": "الرسائل",
    "label_no_messages": "لا توجد رسائل",
    "label_write_message": "اكتب رسالة",
    "label_new_message_admin": "رسالة إلى الإدارة",
    "label_new_message_trainer": "رسالة إلى المدرب",
    "label_start_chat": "ابدأ الدردشة",
    "label_start_conversation": "ابدأ المحادثة",
    "label_chat_active": "نشطة",
    "label_chat_closed": "مغلقة",
    "label_close_conversation": "إغلاق المحادثة",
    "label_close_conversation_confirm": "هل تريد إغلاق هذه المحادثة؟",
    "label_chat_load_error": "تعذر تحميل الدردشة. حاول مرة أخرى لاحقاً.",
    "label_faq": "الأسئلة الشائعة",
    "label_faq_add_new": "إضافة سؤال",
    "label_faq_question": "السؤال",
    "label_faq_answer": "الإجابة",
    "label_faq_order_number": "الترتيب",
    "label_faq_active": "نشط",
    "label_faq_inactive": "غير نشط",
    "label_faq_empty": "لا توجد أسئلة",
    "label_faq_edit": "تعديل السؤال",
    "label_faq_delete_confirm": "هل تريد حذف هذا السؤال؟",
    "label_conversation_not_available": "المحادثة غير متاحة.",
    "label_admin": "الإدارة",
    "label_back": "رجوع",
    "label_selected_users": "المستخدمون المحددون",
    "label_selected_companies": "الشركات المحددة",
    "label_select_all": "تحديد الكل",
    "label_unselect_all": "إلغاء تحديد الكل",
    "label_hide_filters": "إخفاء الفلاتر",
    "label_reset_filters": "إعادة تعيين الفلاتر",
    "label_enter_email_title_en": "أدخل العنوان بالإنجليزية (اختياري)",
    "label_enter_email_text_en": "أدخل النص بالإنجليزية (اختياري)",
    "label_campaign_image_url": "رابط الصورة (اختياري)",
    "label_campaign_error_no_users_selected": "يرجى اختيار مستخدم واحد على الأقل",
    "label_campaign_error_no_companies_selected": "يرجى اختيار شركة واحدة على الأقل",
    "label_campaign_error_title_required": "عنوان الحملة مطلوب",
    "label_campaign_error_message_required": "نص الحملة مطلوب",
    "label_campaign": "حملة",
    "label_campaign_company": "حملة للشركات",
    "label_add_campaign": "إنشاء حملة",
    "label_add_company_campaign": "إنشاء حملة للشركات",
    "label_users_number": "عدد المستخدمين",
    "label_article_in_schedule": "يشمل في الوردية",
    "label_open_door": "افتح الباب",
    "label_trainer_report": "تقرير الموظفين",
    "label_report_type": "النوع",
    "label_report": "تقرير",
    "label_report_total_slots": "إجمالي الجلسات",
    "label_number_slots": "عدد الجلسات",
    "label_tab_orders_reservation": "المنتجات المحجوزة",
    "label_location": "الموقع",
    "label_time_pickup": "وقت الاستلام",
    "label_state_in_warehouse": "المخزون في المستودع",
    "label_please_select_trainer": "يرجى اختيار المدرب",
    "label_show_only_free_slots": "عرض المواعيد المتاحة فقط",
    "label_do_search_by_slot": "تقرير حسب الفتحة",
    "label_do_search_by_user": "تقرير حسب المستخدم",
    "label_reports": "التقارير",
    "label_include_in_schedule": "أضف إلى النوبة",
    "label_additional_cost": "التكلفة",
    "label_schedule_profit": "الربح",
    "label_change_profit": "تغيير الربح",
    "label_articles_report": "تقرير",
    "label_report_summary": "ملخص التقرير",
    "label_by_currency": "حسب العملة",
    "label_total_articles": "إجمالي العناصر",
    "label_margin": "الهامش",
    "label_total": "الإجمالي",
    "label_article_log_report": "تقرير نشاط العناصر",
    "label_article_log_report_hint": "يستخدم نفس تواريخ من/إلى من القسم العلوي.",
    "label_post_on_kp_count": "منشور على KP",
    "label_selling_count": "مباع",
    "label_uploaded_images_for_kp": "الصور المضافة لـ KP",
    "label_article_log_dates_required": "تاريخا من وإلى مطلوبان لهذا التقرير.",
    "label_article_log_invalid_period": "لازم يكون تاريخ من أصغر من أو يساوي تاريخ إلى.",
    "label_c_schedule_user_report": "تقرير الربح حسب المستخدم",
    "label_c_schedule_user_report_hint": "يستخدم نفس تواريخ من/إلى من القسم العلوي.",
    "label_turnover_eur": "الدوران EUR",
    "label_turnover_rsd": "الدوران RSD",
    "label_profit_eur": "الربح EUR",
    "label_are_you_sure_to_show_all": "هل تريد عرض الكل؟",
    "label_end_date": "تاريخ الانتهاء",
    "label_ci_event_edit": "تعديل الحدث",
    "label_ci_event_location": "الموقع",
    "label_ci_event_price": "السعر",
    "label_choose_package": "اختر العضوية",
    "label_view_table": "عرض الجدول",
    "label_view_slot": "عرض جميع الفترات",
    "label_expire_to_days": "ينتهي خلال ... يوم",
    "label_download_user_report": "عرض التقرير",
    "label_trainer": "المدرب",
    "label_mp_for_program": "هل هذه عضوية للبرنامج؟",
    "label_program_buy": "شراء البرنامج",
    "label_start_program": "ابدأ البرنامج",
    "label_program_filter_all": "جميع البرامج",
    "label_program_filter_bought": "تم الشراء",
    "label_program_filter_free": "مجاني",
    "label_program_filter_lock": "مقفل",
    "label_program_is_free": "هل البرنامج مجاني؟",
    "label_program_is_template": "هل تريد أن يكون برنامجًا مُعدًا مسبقًا؟",
    "label_regular_sell": "البيع",
    "label_regular_supply": "التوريد المنتظم",
    "label_pp_short_desc": "الوصف المختصر",
    "label_pp_short_desc_en": "الوصف المختصر (en)",
    "label_pp_long_desc": "الوصف المطول",
    "label_pp_long_desc_en": "الوصف المطول (en)",
    "label_total_price": "السعر الإجمالي",
    "label_returned_amount": "الباقي",
    "label_schedule_item": "تعديل عنصر الوردية",
    "label_type_active": "مفتوحة",
    "label_type_closed": "مغلقة",
    "label_type_approved": "معتمدة",
    'label_article_for_change_button': 'عنصر للاستبدال',
    'label_color_delete_are_you_sure': 'سيتم حذف اللون من السجل',
    'delete_color_from_history': 'احذف اللون من السجل',
    'label_article_changed': 'رموز العناصر الجديدة',
    'label_change_for': 'استبدال',
    'label_success_open_door': 'تم فتح الباب بنجاح',
    'scanner_control': 'التحكم في الماسح',
    'scanner_focus': 'الماسح في التركيز',
    'scanner_not_focus': 'الماسح ليس في التركيز',
    'focus_scanner': 'ركز الماسح',
    'last_scanned_user': 'آخر مستخدم تم مسحه',
    'scanning_in_progress': 'جاري المسح',
    'label_add_on_current_state_trainings': 'أضف المواعيد على الحالة الحالية؟',
    'label_si_all': 'الكل',
    'label_si_sell': 'بيع',
    'label_si_buy': 'شراء',
    'label_si_purchase': 'توريد',
    'label_si_additional_cost': 'تكلفة إضافية',
    "label_timed_slots": "الفترات الزمنية",
    "label_are_you_sure_delete_timed_slot": "هل أنت متأكد أنك تريد الحذف",
    "label_timed_slot_success_delete": "تم الحذف بنجاح",
    "label_are_you_sure_checkout_timed_slot": "هل أنت متأكد أنك تريد تسجيل الخروج",
    "label_timed_slot_name": "اسم المورد",
    "label_capacity": "السعة",
    "label_start": "بداية",
    "label_end": "نهاية",
    "label_checkout": "تسجيل الخروج",
    "label_extend": "تمديد",
    "label_no_active_guests": "لا يوجد ضيوف نشطون.",
    "label_add_new_timed_slot": "إضافة مورد جديد",
    "label_capacity_progress": "نسبة الإشغال",
    "label_expired": "منتهي",
    "label_rest": "المتبقي",
    "label_choose_resource_for_check_in": "اختر المورد لتسجيل دخول المستخدم.",
    "label_set_number_in_minutes": "أدخل القيمة بالدقائق",
    "label_extended": "تم التمديد",
    "label_choose_shop_item": "اختر المنتج",
    "label_add_shop_item": "+ منتج",
    "label_click_to_select_shop_item": "اختر",
    "label_shop_item": "المنتج",
    "label_ended": "تم تسجيل الخروج",
    "label_finished": "منتهي",
    "label_article_is_new": "مقالة جديدة؟",
    "label_new_article": "جديد",
    "label_used_article": "مستعمل",
    "label_article_condition": "الحالة",
    "label_kp_posted": "حالة KP",
    "label_kp_posted_yes": "منشور على KP",
    "label_kp_posted_no": "غير منشور",
    "label_filter_add_info_memory": "ذاكرة إضافية (مطابقة)",
    "label_filter_ram_memory": "RAM (مطابقة)",
    "label_filter_color_partial": "اللون",
    "label_bar_pos": "البار",
    "label_quick_sell": "بيع سريع",
    "label_all": "الكل",
    "label_bills": "فواتير",
    "label_cart": "السلة",
    "label_cart_items": "العناصر",
    "label_cart_approve": "تأكيد",
    "label_cart_not_on_stock": "غير متوفر",
    "label_cart_added": "تمت الإضافة",
    "label_shop_item_state": "الحالة",
    "label_group_by_user": "تجميع حسب المستخدم",
    "label_group_by_product": "تجميع حسب المنتج",
    "label_sell_product": "تم البيع",
    "label_nothing_found": "لا توجد عناصر",
    "label_loading": "جاري التحميل...",
    "label_results": "النتائج",
    "label_user_type_personal": "شخصي",
    "label_verify_are_you_sure": "تحقق من المستخدم",
    "label_verify": "تحقق",
    "label_registered": "مسجل",
    "label_sort_by": "فرز حسب",
    "label_direction": "اتجاه الفرز",
    "label_direction_up": "تصاعدي",
    "label_direction_down": "تنازلي",
    "label_created_at": "تاريخ التسجيل",
    "label_last_activity": "وقت آخر نشاط",
    "label_paid_date": "تاريخ الدفع",
    "label_expire_date": "تاريخ الانتهاء",
    "label_membership_type": "نوع الدفع الظاهر في التطبيق",
    "label_update_user_profile": "ملف المستخدم",
    "label_user_profile_details": "تفاصيل الحساب",
    "label_user_payment_details": "قائمة الدفعات",
    "label_add_sign_up_user": "تسجيل المستخدم",
    "label_membership_subscription": "اشتراك",
    "label_membership_one_payment": "دفع لمرة واحدة",
    "label_membership_both": "اشتراك ودفع لمرة واحدة",
    "label_ci_knowledge": "قاعدة المعرفة",
    "label_ci_knowledge_add": "أضف عنصر",
    "label_ci_knowledge_name": "الاسم",
    "label_ci_knowledge_name_en": "الاسم (إنجليزي)",
    "label_ci_knowledge_embeded_video_link": "رابط فيديو مضمن",
    "label_preview": "معاينة",
    "label_copy_to_notification": "نسخ إلى الإشعارات",
    "label_cash_register": "الكاشير",
    "label_cash_current_state": "الرصيد الحالي",
    "bill_status_finished": "مكتمل",
    "bill_status_pending": "قيد الانتظار",
    "label_simple_search": "بحث بسيط",
    "label_advanced_search": "بحث متقدم",
    "label_create_custom_bill": "إنشاء فاتورة",
    "label_fill_custom_bill": "عند إنشاء هذه الفاتورة، سيتم زيادة رصيد الكاشير بالمبلغ الذي تدخله",
    "label_bill_enter_name": "اكتب اسم الفاتورة، مثل: بيع اشتراك معيّن...",
    "label_bill_enter_amount": "أدخل مبلغ الفاتورة",
    "label_bill_optional_comment": "أدخل ملاحظة (اختياري)",
    "label_save_bill": "حفظ الفاتورة",
    "label_cart_description": "اضغط على أي منتج لإضافته إلى السلة",
    "label_cash_cashout": "سحب من الكاشير",
    "label_fill_required_fields": "الحقول المطلوبة هي الاسم، المبلغ الإجمالي، والتصنيف",
    "label_saving": "الرجاء الانتظار",
    "bill_status_from_canceled": "من فاتورة ملغاة",
    "bill_status_canceled": "ملغاة",
    "label_bill_cancel": "إلغاء",
    "label_storn_bill_description": "هل أنت متأكد أنك تريد إلغاء هذه الفاتورة؟",
    "label_shop_category_shop": "المتجر",
    "label_shop_category_membership": "الاشتراكات",
    "label_shop_category_all": "الكل",
    "label_articles_report_not_permit": "ما عندك صلاحية للوصول إلى التقرير",
    "label_not_permit_action": "ما عندك صلاحية تسوي هالإجراء",
    "label_show_inventory": "عرض فلتر الجرد",
    "label_hide_inventory": "إخفاء فلتر الجرد",
    "label_last_inventory": "ضمن الجرد",
    "label_last_inventory_label": "آخر جرد",
    "label_last_inventory_update": "تحديث",
    "label_last_inventory_update_label": "تحديث الجرد",
    "label_are_you_sure_to_update_inventory": "هل أنت متأكد أنك تريد تحديث الجرد لـ",
    "label_article_inventory_success": "تم تحديث الجرد بنجاح",
    "label_are_you_sure_to_update_inventory_not_in_stock": "الصنف غير متوفر حالياً! عند تحديث الجرد سيتم إضافته إلى المخزون",
    "label_warehouse": "المخزن",
    "label_warehouse_items_title": "أصناف المخزن",
    "label_warehouse_item_add_title": "إضافة صنف للمخزن",
    "label_warehouse_item_edit_title": "تعديل صنف المخزن",
    "label_inventory_history": "سجل الجرد",
    "label_inventory_history_subtitle": "قائمة عمليات الجرد المحفوظة",
    "label_inventory": "الجرد",
    "label_create_inventory": "إنشاء جرد",
    "label_inventory_add_title": "جرد جديد",
    "label_inventory_add_subtitle": "أدخل الكمية المعدودة لكل صنف",
    "label_current_stock_number": "المخزون الحالي",
    "label_inventory_quantity": "الكمية المعدودة",
    "label_confirm_inventory": "تأكيد الجرد",
    "label_inventory_changed_items": "العناصر المعدلة",
    "label_inventory_saved": "تم حفظ الجرد بنجاح",
    "label_inventory_no_changes": "لا توجد عناصر معدلة للحفظ",
    "label_inventory_invalid_quantity": "يجب أن تكون الكمية رقمًا صحيحًا أكبر من أو يساوي 0",
    "label_note": "ملاحظة",
    "label_stock_number": "الكمية المراد إضافتها",
    "label_company_info_id": "رقم الشركة",
    "label_add": "إضافة",
    "label_no_data": "ما في بيانات",
    "label_success_delete": "تم الحذف بنجاح",
    "label_all_field_required": "كل الحقول المطلوبة لازم تتعبى",
    "label_are_you_sure_delete": "متأكد؟",
    "label_are_you_sure_delete_desc": "متأكد إنك تبي تحذف الصنف؟",
    "label_purchase_price": "سعر الشراء",
    "label_pay_with_credits": "الدفع بالكريدت",
    "label_paid_with_credits": "مدفوع بالكريدت",
    "label_paid_with": "طريقة الدفع",
    "label_cash": "نقداً",
    "label_card": "بطاقة",
    "label_online_card": "بطاقة أونلاين",
    "label_bar_pos_debt": "غير مدفوع",
    "label_pay_bill_description": "راح يتم تعيين الفاتورة كمدفوعة",
    "label_waiting_list_active": "نشطين",
    "label_waiting_list_active_one": "نشط",
    "label_waiting_list_waiting": "على الانتظار",
    "label_waiting_list_expired": "منتهين",
    "label_profit": "الأرباح",
    "label_period": "الفترة",
    "label_total_profit": "إجمالي الأرباح",
    "label_items_count": "العناصر",
    "label_show": "عرض",
    "label_no_profit_data_for_period": "ما في بيانات للفترة المختارة",
    "label_profit_tab_orders": "المتجر",
    "label_profit_tab_payments": "العضويات",
    "label_total_reservations": "إجمالي الحجوزات",
    "label_most_popular_term": "أكثر موعد شعبية",
    "label_most_popular_term_reservations": "حجوزات الموعد الأكثر شعبية",
    "label_most_popular_terms": "المواعيد الأكثر شعبية",
    "label_term_occupancy": "نسبة إشغال المواعيد",
    "label_full_terms": "مواعيد ممتلئة",
    "label_no_data_for_period": "ما في بيانات للفترة",
    "label_no_weekly_report_data": "ما في بيانات للتقرير الأسبوعي",
    "label_weekly_report_title": "تقرير أسبوعي",
    "label_entrance_total": "إجمالي الدخول",
    "label_entrance_most_popular_time": "أكثر وقت شعبية",
    "label_entrance_count_then": "عدد الدخول بهذا الوقت",
    "label_entrance_by_bucket": "الدخول حسب",
    "label_no_entrance_data_for_period": "ما في دخول للفترة المختارة",
    "label_hour": "الساعة",
    "label_time_bucket": "الفاصل الزمني",
    "label_toggle_navigation_menu": "فتح/إغلاق قائمة التنقل",
    "label_close_navigation_menu": "إغلاق قائمة التنقل",
    "label_light_theme": "الوضع الفاتح",
    "label_dark_theme": "الوضع الداكن",
    "label_expand_sidebar": "توسيع الشريط الجانبي",
    "label_collapse_sidebar": "طي الشريط الجانبي",
    "label_switch_to_topbar": "نقل القائمة للأعلى",
    "label_switch_to_sidebar": "إرجاع القائمة لليسار",
    "label_reserving_training": "جاري حجز التمرين...",
    "label_canceling_training": "جاري إلغاء التمرين...",
    "label_no_trainer": "بدون مدرب",
    "label_no_type": "بدون نوع",
    "label_waiting_list_title": "قائمة الانتظار",
    "label_user_report": "تقرير المستخدمين",
    "label_total_registrations": "إجمالي التسجيلات",
    "label_total_deleted_users": "إجمالي المستخدمين المحذوفين",
    "label_expiring_this_month": "تنتهي هذا الشهر",
    "label_avg_renewal_rate": "متوسط معدل التجديد",
    "label_registrations_vs_deleted": "التسجيلات مقابل المحذوفين",
    "label_registrations": "التسجيلات",
    "label_deleted_users": "المستخدمون المحذوفون",
    "label_renewal": "التجديد",
    "label_expired_users": "المستخدمون المنتهون",
    "label_not_renewed_users": "غير المجددين",
    "label_renewal_rate": "معدل التجديد",
    "label_cohort_retention": "احتفاظ الكوهورت",
    "label_cohort_month": "شهر الكوهورت",
    "label_cohort_size": "حجم الكوهورت",
    "label_m1_active": "نشط M1",
    "label_m2_active": "نشط M2",
    "label_m3_active": "نشط M3",
    "label_invalid_date_range": "نطاق تاريخ غير صالح",
}

let TRANSLATION = {
    EN: T_EN,
    SR: T_SR,
    AR: T_AR
}
export default TRANSLATION



// WEBPACK FOOTER //
// ./src/services/translations.js